// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AuditOS Styles */
.audit-layout {
  height: 100vh;
  overflow: hidden;
  font-family: "Plus Jakarta Sans", system-ui, -apple-system, sans-serif;
}

.audit-sidebar {
  height: 100%;
}

.sidebar-enter {
  animation: sidebarIn 350ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-brand {
  position: relative;
}

.audit-panel {
  background: transparent;
}

.audit-active-audit {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 10px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.audit-health-pulse {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  display: inline-block;
  animation: healthPulse 1.9s ease-in-out infinite;
}

.audit-health-pulse.good {
  background: #10b981;
  --pulse-color: rgba(16, 185, 129, 0.45);
}

.audit-health-pulse.warn {
  background: #f59e0b;
  --pulse-color: rgba(245, 158, 11, 0.45);
}

.audit-health-pulse.risk {
  background: #ef4444;
  --pulse-color: rgba(239, 68, 68, 0.45);
}

.section-dot {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #10b981;
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.35);
}

.audit-chip {
  color: #cbd5e1;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.02);
}

.audit-chip:hover {
  background: rgba(255, 255, 255, 0.07);
}

.audit-chip.active {
  background: rgba(16, 185, 129, 0.14);
  border-color: rgba(16, 185, 129, 0.32);
  color: #ecfdf5;
  box-shadow: inset 0 0 0 1px rgba(16, 185, 129, 0.2);
}

.audit-header {
  height: 100%;
}

.header-shell {
  height: 100%;
}


.header-bar {
  align-items: center;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(220px, 1.15fr) minmax(280px, 1fr) minmax(320px, 1.1fr);
  height: 100%;
}

.header-left,
.header-center,
.header-right {
  min-width: 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-brand {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.header-audit-chip {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #0f172a;
  display: inline-flex;
  gap: 10px;
  max-width: 100%;
  min-height: 32px;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 600;
}

.header-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #16a34a;
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);
  flex-shrink: 0;
}

.header-brand-caption {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding-left: 6px;
}

.header-center {
  display: flex;
  justify-content: center;
}

.header-search-wrap {
  position: relative;
  width: min(100%, 420px);
}

.header-search-icon {
  color: #64748b;
  left: 14px;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.header-search-input {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #0f172a !important;
  height: 40px;
  padding-left: 42px !important;
}

.header-search-input::placeholder {
  color: #94a3b8;
}

.header-right {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: nowrap;
}

.header-date-pill {
  white-space: nowrap;
}

.header-avatar {
  flex-shrink: 0;
}

.audit-main {
  grid-row: 2;
  grid-column: 2;
  overflow: hidden;
  position: relative;
  padding: 0;
  background:
    radial-gradient(circle at top right, rgba(5, 150, 105, 0.08), transparent 22%),
    radial-gradient(circle at top left, rgba(16, 185, 129, 0.06), transparent 20%),
    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  box-shadow:
    inset 1px 0 0 #dbe4f0,
    inset -1px 0 0 #dbe4f0,
    inset 0 -1px 0 #dbe4f0;
}

.audit-main::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 196px;
  background:
    radial-gradient(circle at top right, rgba(226, 232, 240, 0.22), transparent 30%),
    linear-gradient(120deg, #f8fafc 0%, #f1f5f9 55%, #e2e8f0 100%);
  z-index: 0;
}

.audit-main > * {
  position: relative;
  z-index: 1;
}

.audit-main > [data-testid="integrations-page"],
.audit-main > [data-testid="model-config-page"],
.audit-main > [data-testid="audit-logs-page"],
.audit-main > [data-testid="user-management-page"] {
  margin-top: 0.75rem;
}

.dark .audit-main {
  background: #121722;
  box-shadow:
    inset 1px 0 0 #292f3b,
    inset -1px 0 0 #292f3b,
    inset 0 -1px 0 #292f3b;
}

.dark .audit-main::before {
  background:
    radial-gradient(circle at top right, rgba(148, 163, 184, 0.18), transparent 28%),
    linear-gradient(120deg, #0b1220 0%, #111827 42%, #1f2937 100%);
}

.dark .audit-main .bg-card,
.dark .audit-main [class*="bg-card/"],
.dark .audit-main .bg-background {
  background-color: hsl(var(--card)) !important;
}



/* Phase progress */
.phase-step {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.phase-step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  z-index: 1;
  transition: all 200ms ease;
  animation: phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--phase-delay, 0ms);
}

.phase-step-line {
  position: absolute;
  top: 14px;
  left: 50%;
  width: 100%;
  height: 2px;
  z-index: 0;
  background: hsl(var(--border));
  overflow: hidden;
}

.phase-step-line::after {
  content: "";
  position: absolute;
  inset: 0;
  transform-origin: left center;
  transform: scaleX(0);
  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--chart-2)));
}

.phase-step-line.is-active::after {
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);
}

.phase-step-button:hover .phase-step-dot {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.08);
}

.phase-step-dot.is-current {
  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);
  animation:
    phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both,
    currentPhasePulse 2.6s ease-in-out infinite;
  animation-delay: var(--phase-delay, 0ms), calc(var(--phase-delay, 0ms) + 420ms);
}

.phase-step-dot.is-complete {
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
}

.phase-progress-shell .phase-step span {
  animation: rowIn 320ms ease both;
  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);
}

/* Labels */
.label-xs {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* Data table density */
.table-dense th,
.table-dense td {
  padding: 0.5rem 0.75rem;
  font-size: 0.8125rem;
}

.table-dense th {
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Severity badges */
.severity-high {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.severity-high:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
  background-color: rgb(69 10 10 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.severity-medium {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.severity-medium:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity, 1));
  background-color: rgb(69 26 3 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.severity-low {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.dark .audit-main .severity-low {
  color: #f8fafc;
}
.severity-low:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  background-color: rgb(2 6 23 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.severity-observation {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.dark .audit-main .severity-observation {
  color: #f8fafc;
}
.severity-observation:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  background-color: rgb(2 6 23 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

/* Status indicators */
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-ready {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-ingesting {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-parsing {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-extracting {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.status-uploaded {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}

/* Chat message animation */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.chat-message-enter {
  animation: fadeInUp 200ms ease-out;
}

/* Ambient Motion Layer */
.ambient-canvas {
  position: relative;
  isolation: isolate;
}

.audit-main .ambient-orb,
.audit-main .ambient-particles {
  display: block;
}

/* Keep dashboard content white over the branded surface */
.audit-main .bg-card,
.audit-main [class*="bg-card/"],
.audit-main .bg-background {
  background-color: #ffffff !important;
}

.audit-main .border {
  border-color: rgba(129, 140, 248, 0.28);
}

/* Make top phase header text readable over the hero strip */
.audit-main [data-testid^="phase-"] > div:first-child h2 {
  color: #0f172a !important;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);
}

.audit-main .section-content {
  padding: 1.5rem 2rem 2rem;
} 

.audit-main [data-testid^="phase-"] > div:first-child p {
  color: #475569 !important;
}

.audit-main [data-testid^="phase-"] {
  animation: phasePageIn 560ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-main [data-testid^="phase-"] > * {
  animation: phaseSectionIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-main [data-testid^="phase-"] > *:nth-child(1) { animation-delay: 40ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(2) { animation-delay: 110ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(3) { animation-delay: 180ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(4) { animation-delay: 250ms; }
.dark .audit-main [data-testid^="phase-"] > div:first-child h2 {
  color: #ffffff !important;
  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.4);
}

.dark .audit-main [data-testid^="phase-"] > div:first-child p {
  color: #d1fae5 !important;
}
.audit-main [data-testid^="phase-"] > *:nth-child(5) { animation-delay: 320ms; }

/* Phase 7 command-center treatment */
.phase7-hero {
  position: relative;
  isolation: isolate;
  border-color: rgba(148, 163, 184, 0.24);
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.92) 48%, rgba(241, 245, 249, 0.96) 100%),
    radial-gradient(circle at 12% 0%, rgba(16, 185, 129, 0.12), transparent 30%),
    radial-gradient(circle at 88% 18%, rgba(148, 163, 184, 0.12), transparent 36%);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.85);
  animation: heroGradientDrift 14s ease-in-out infinite alternate;
}

.phase7-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: linear-gradient(180deg, black, transparent 78%);
}

.phase7-hero p,
.phase7-hero h2 {
  color: inherit !important;
}

.phase7-hero .text-slate-300 {
  color: #475569 !important;
}

.phase7-hero .text-slate-400 {
  color: #64748b !important;
}

.phase7-hero .text-cyan-200\\/90 {
  color: rgba(8, 145, 178, 0.9) !important;
}

/* Dark mode overrides for Phase 7 hero card and stats */
.dark .phase7-hero {
  border-color: rgba(148, 163, 184, 0.14);
  background:
    linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(23, 29, 46, 0.96) 48%, rgba(30, 41, 59, 0.98) 100%),
    radial-gradient(circle at 12% 0%, rgba(16, 185, 129, 0.16), transparent 30%),
    radial-gradient(circle at 88% 18%, rgba(148, 163, 184, 0.12), transparent 36%);
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.36), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.dark .phase7-hero::after {
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);
}

.dark .phase7-hero .text-slate-300 {
  color: #cbd5e1 !important;
}

.dark .phase7-hero .text-slate-400 {
  color: #94a3b8 !important;
}

.dark .phase7-hero .text-cyan-200\\/90 {
  color: rgba(165, 243, 252, 0.95) !important;
}

.phase7-stat {
  backdrop-filter: blur(10px);
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;
}

.phase7-stat:hover {
  transform: translateY(-2px);
  border-color: rgba(16, 185, 129, 0.26);
  background: rgba(255, 255, 255, 0.86);
}

.dark .phase7-stat:hover {
  border-color: rgba(16, 185, 129, 0.4);
  background: rgba(30, 41, 59, 0.86);
}

.phase7-console-card,
.phase7-control-row,
.phase7-progress-card {
  animation: phaseSectionIn 480ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.phase7-console-card {
  overflow: hidden;
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.08);
}

.dark .phase7-console-card {
  background:
    linear-gradient(180deg, rgba(23, 29, 46, 0.94), rgba(15, 23, 42, 0.96)) !important;
  border-color: rgba(129, 140, 248, 0.22) !important;
  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dark .phase7-control-panel,
.dark .phase7-progress-card {
  background: rgba(2, 6, 23, 0.28) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
}

.dark .phase7-control-row {
  background: rgba(15, 23, 42, 0.72) !important;
  border-color: rgba(148, 163, 184, 0.16) !important;
}

.dark .phase7-control-row:hover {
  border-color: rgba(45, 212, 191, 0.34) !important;
}

/* Phase 10 readability on the branded dashboard */
.phase10-readable,
.phase10-readable * {
  color: #0f172a;
}

.phase10-readable .text-muted-foreground {
  color: #111827 !important;
}

.phase10-readable .text-\\[10px\\],
.phase10-readable .text-\\[9px\\],
.phase10-readable .text-\\[8px\\] {
  color: #1f2937 !important;
}

.phase10-no-gap {
  margin: -24px -24px 0;
  padding: 0 8px 24px;
}

.phase10-report-header {
  margin: 0 -8px;
  padding: 18px 20px;
  border: 1px solid rgba(5, 150, 105, 0.16);
  border-radius: 18px;
  background:
    radial-gradient(circle at top right, rgba(167, 243, 208, 0.22), transparent 30%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.97) 0%, rgba(248, 250, 252, 0.96) 48%, rgba(236, 253, 245, 0.95) 100%);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
}

.phase10-report-header-attached {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.phase10-report-header .bg-white\\/80,
.phase10-report-header [class*="bg-card"],
.phase10-report-header [class*="bg-background"] {
  background-color: rgba(255, 255, 255, 0.76) !important;
}

.phase10-report-header button,
.phase10-report-header [role="combobox"] {
  border-color: rgba(148, 163, 184, 0.22) !important;
  color: #0f172a;
}

.phase10-report-header button:hover,
.phase10-report-header [role="combobox"]:hover {
  background-color: rgba(241, 245, 249, 0.9) !important;
}

.dark .phase10-report-header {
  border: 1px solid rgba(52, 211, 153, 0.18);
  background:
    radial-gradient(circle at top right, rgba(52, 211, 153, 0.16), transparent 30%),
    linear-gradient(120deg, #0f172a 0%, #064e3b 42%, #111827 100%);
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.22);
}

.dark .phase10-report-header .bg-white\\/80,
.dark .phase10-report-header [class*="bg-card"],
.dark .phase10-report-header [class*="bg-background"] {
  background-color: rgba(15, 23, 42, 0.72) !important;
}

.dark .phase10-report-header button,
.dark .phase10-report-header [role="combobox"] {
  border-color: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff;
}

.dark .phase10-report-header button:hover,
.dark .phase10-report-header [role="combobox"]:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.phase10-command-brief {
  margin-top: -1.5rem !important;
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.ambient-orb {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  filter: blur(34px);
  opacity: 0.2;
  border-radius: 9999px;
  animation: orbFloat 10s ease-in-out infinite alternate;
}

.orb-one {
  width: 280px;
  height: 280px;
  right: 14%;
  top: 18%;
  background: radial-gradient(circle, rgba(16,185,129,0.28) 0%, rgba(16,185,129,0) 70%);
}

.orb-two {
  width: 220px;
  height: 220px;
  right: 34%;
  bottom: 8%;
  background: radial-gradient(circle, rgba(52,211,153,0.22) 0%, rgba(52,211,153,0) 70%);
  animation-delay: 1.2s;
}

.ambient-particles {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background-image:
    radial-gradient(circle at 10% 18%, rgba(110,231,183,0.18) 1px, transparent 1.6px),
    radial-gradient(circle at 70% 35%, rgba(16,185,129,0.15) 1px, transparent 1.6px),
    radial-gradient(circle at 35% 72%, rgba(45,212,191,0.15) 1px, transparent 1.6px);
  background-size: 320px 320px, 260px 260px, 380px 380px;
  animation: particlesDrift 16s linear infinite;
  display: none;
}

/* Sidebar and Nav Animations */
.sidebar-logo-anim {
  transform-origin: center;
  transition: transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.sidebar-logo-anim:hover {
  transform: rotate(-7deg) scale(1.06);
}

.sidebar-nav-item {
  position: relative;
  overflow: hidden;
  animation: navItemIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--stagger, 0ms);
  transition: transform 170ms ease, box-shadow 170ms ease;
}

.sidebar-nav-item:hover {
  transform: translateX(3px);
}

.sidebar-nav-item .nav-icon {
  transition: transform 180ms ease, color 180ms ease;
}

.sidebar-nav-item:hover .nav-icon {
  transform: scale(1.08);
  color: #10b981;
}

.sidebar-nav-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18%;
  height: 64%;
  width: 3px;
  border-radius: 999px;
  background: #10b981;
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.5);
}

.sidebar-stepper {
  position: relative;
}

.sidebar-stepper::before {
  display: none;
}

.sidebar-stepper .sidebar-nav-item {
  padding-left: 0.95rem;
}

.sidebar-journey-progress {
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
  box-shadow: 0 0 14px rgba(139, 92, 246, 0.35);
  transition: width 260ms ease;
}



.sidebar-stepper .sidebar-nav-item.is-complete .nav-icon {
  color: #c4b5fd;
}

.sidebar-profile-avatar {
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.16), 0 8px 20px rgba(30, 41, 59, 0.18);
}

.profile-summary-avatar {
  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.16), 0 10px 24px rgba(30, 41, 59, 0.2);
}

/* Quick Action Micro-Interaction */
.quick-action {
  transition: transform 160ms ease, color 160ms ease;
}

.quick-action:hover {
  transform: translateX(4px);
}

/* Metric Card Entrance + Hover Lift */
.metric-card-anim {
  position: relative;
  overflow: hidden;
  animation: metricIn 580ms cubic-bezier(0.2, 0.9, 0.15, 1.1) both;
  animation-delay: var(--delay, 0ms);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.metric-card-anim::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(16,185,129,0), rgba(16,185,129,0.8), rgba(16,185,129,0));
  opacity: 0;
  transform: translateY(2px);
  transition: opacity 180ms ease, transform 180ms ease;
}

.metric-card-anim:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.metric-card-anim:hover::after {
  opacity: 1;
  transform: translateY(0);
}

.audit-card {
  position: relative;
  overflow: hidden;
}

.audit-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.08) 18%, transparent 36%);
  opacity: 0;
  transform: translateX(-18%);
  transition: opacity 220ms ease, transform 420ms ease;
  pointer-events: none;
}

.audit-card:hover::before {
  opacity: 1;
  transform: translateX(18%);
}

.dark .audit-card:hover {
  box-shadow: 0 24px 50px rgba(2, 6, 23, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.executive-glass {
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.9), rgba(236, 253, 245, 0.78)) !important;
  border: 1px solid rgba(16, 185, 129, 0.18) !important;
  box-shadow: 0 16px 34px rgba(16, 185, 129, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(10px);
}

.dark .executive-glass {
  background: linear-gradient(140deg, rgba(26, 26, 27, 0.72), rgba(17, 24, 39, 0.55)) !important;
  border-color: rgba(45, 212, 191, 0.35) !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.executive-hero {
  background: linear-gradient(120deg, #064e3b 0%, #059669 52%, #34d399 100%) !important;
  box-shadow: 0 16px 30px rgba(5, 150, 105, 0.18);
}

.hero-progress-wrap {
  min-width: 250px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(254, 202, 202, 0.5);
  border-radius: 16px;
  padding: 12px;
  backdrop-filter: blur(6px);
}

.hero-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
}

.hero-progress-track {
  height: 8px;
  border-radius: 999px;
  margin-top: 8px;
  background: rgba(254, 202, 202, 0.44);
  overflow: hidden;
}

.hero-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #fee2e2, #ffffff);
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  position: relative;
  overflow: hidden;
}

.hero-progress-fill::after,
.quick-actions-fill::after,
.assistant-task-fill::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 48%, transparent 100%);
  transform: translateX(-120%);
  animation: scanSweep 1.9s ease-in-out infinite;
}

/* Table Row Reveal + Progress */
.table-row-anim {
  animation: rowIn 380ms ease both;
  animation-delay: var(--row-delay, 0ms);
}

.audit-main table tbody tr {
  animation: rowIn 420ms ease both;
}

.audit-main table tbody tr:nth-child(1) { animation-delay: 50ms; }
.audit-main table tbody tr:nth-child(2) { animation-delay: 90ms; }
.audit-main table tbody tr:nth-child(3) { animation-delay: 130ms; }
.audit-main table tbody tr:nth-child(4) { animation-delay: 170ms; }
.audit-main table tbody tr:nth-child(5) { animation-delay: 210ms; }

.progress-anim {
  transform-origin: left center;
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  animation-delay: 120ms;
}

.progress-bar-indicator {
  position: relative;
  overflow: hidden;
}

.progress-bar-indicator::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.35) 45%, transparent 100%);
  transform: translateX(-125%);
  animation: scanSweep 2.1s ease-in-out infinite;
}

/* Notification Pulse */
.notification-pulse {
  animation: bellPulse 1.8s ease-in-out infinite;
}

/* Floating AI Button */
.floating-ai-btn {
  position: fixed;
  right: 1.2rem;
  bottom: 1.2rem;
  z-index: 40;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #047857, #10b981);
  color: white;
  box-shadow: 0 16px 32px rgba(16, 185, 129, 0.24);
  animation: floatBtnIn 540ms cubic-bezier(0.2, 0.95, 0.2, 1.2) both;
}

.audit-chat-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(254, 242, 242, 0.98) 100%);
  color: hsl(var(--foreground));
}

.dark .copilot-shell {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: hsl(var(--foreground));
}

.audit-chat-panel .chat-header {
  background: rgba(255, 255, 255, 0.72);
  border-color: hsl(var(--border));
}

.audit-chat-panel .chat-composer {
  background: rgba(255, 255, 255, 0.78);
  border-color: hsl(var(--border));
}

/* Light mode - copilot shell defaults */
.copilot-shell {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: hsl(var(--foreground));
}

.copilot-header {
  padding: 16px 14px;
  background: rgba(255, 255, 255, 0.86);
  border-color: hsl(var(--border));
}

.copilot-title {
  color: #4f46e5;
  font-size: clamp(0.95rem, 1.4vw, 1.125rem);
  line-height: 1.1;
}

.copilot-context {
  color: hsl(var(--muted-foreground));
  letter-spacing: 0.14em;
  line-height: 1.25;
}

.copilot-avatar {
  border: 2px solid rgba(79, 70, 229, 0.5);
}

.copilot-icon-btn {
  color: #4f46e5;
  background: rgba(79, 70, 229, 0.08);
  border: 1px solid rgba(79, 70, 229, 0.2);
}

.copilot-icon-btn:hover {
  background: rgba(79, 70, 229, 0.12);
  color: #4338ca;
}

.copilot-scroll {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px),
    linear-gradient(0deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.copilot-day-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: hsl(var(--muted-foreground));
  font-size: 12px;
  font-weight: 700;
}

.copilot-day-divider::before,
.copilot-day-divider::after {
  content: "";
  height: 1px;
  flex: 1 1;
  background: hsl(var(--border));
  opacity: 0.6;
}

.copilot-day-divider {
  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.copilot-context-card {
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(6, 182, 212, 0.04) 100%);
  border-color: rgba(79, 70, 229, 0.2);
  border-radius: 16px;
  min-width: 0;
  overflow: hidden;
}

.copilot-welcome {
  background: linear-gradient(135deg, rgba(20, 184, 166, 0.06) 0%, rgba(6, 182, 212, 0.04) 100%);
  border-color: rgba(20, 184, 166, 0.25);
  min-width: 0;
  overflow: hidden;
}

.copilot-welcome-actions > button {
  max-width: 100%;
  white-space: nowrap;
}

.copilot-welcome .bg-primary {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.copilot-welcome .bg-primary:hover {
  background: linear-gradient(135deg, #818cf8, #a78bfa);
}

.copilot-bot-mark {
  background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%);
  color: #ffffff;
  position: relative;
  overflow: hidden;
}

.copilot-user-mark {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #ffffff;
  border: none;
}

.copilot-message-row {
  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--message-delay, 0ms);
}

.message-user-row {
  transform-origin: right center;
}

.message-assistant-row {
  transform-origin: left center;
}

.copilot-message {
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.copilot-user-message {
  border-top-right-radius: 6px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.26);
}

.copilot-user-message::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);
  transform: translateX(-120%);
  animation: messageShimmer 4.2s ease-in-out infinite;
}

.copilot-assistant-message {
  border-top-left-radius: 6px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-color: rgba(79, 70, 229, 0.15);
}

.copilot-message-text {
  color: hsl(var(--foreground));
}

.copilot-message-text strong {
  color: hsl(var(--foreground));
  font-weight: 600;
}

.audit-chat-panel .quick-action {
  background: hsl(var(--card));
  border-color: hsl(var(--border));
  color: hsl(var(--foreground));
}

.audit-chat-panel .quick-action:hover {
  border-color: hsl(var(--primary));
  background: hsl(var(--accent));
}

.copilot-evidence-card {
  background: hsl(var(--accent));
  border-color: hsl(var(--border));
}

.copilot-composer {
  background: hsl(var(--card));
  border-color: hsl(var(--border));
}

.copilot-chip {
  background: hsl(var(--secondary));
  color: hsl(var(--secondary-foreground));
  border-color: hsl(var(--border));
}

.copilot-chip:hover {
  background: hsl(var(--secondary))\\/90;
}

.copilot-input-shell {
  background: hsl(var(--input));
  border-color: hsl(var(--border));
  color: hsl(var(--foreground));
}

.copilot-input-icon {
  color: hsl(var(--muted-foreground));
}

.copilot-input-icon:hover {
  color: hsl(var(--foreground));
}

.copilot-send {
  background: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
}

.copilot-send:hover {
  background: hsl(var(--primary))\\/90;
}

.copilot-send-armed {
  box-shadow: 0 0 18px rgba(79, 70, 229, 0.42);
}

.copilot-send-armed::after {
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4) 40%, transparent);
}

.copilot-thinking-row {
  background: transparent;
}

.copilot-thinking-mark {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #ffffff;
}

.copilot-thinking-bubble {
  background: hsl(var(--card));
  border-color: hsl(var(--border));
  color: hsl(var(--foreground));
}

.copilot-typing-dots span {
  background: hsl(var(--muted-foreground));
}

.dark .audit-sidebar {
  background:
    radial-gradient(circle at top left, rgba(16, 185, 129, 0.12), transparent 28%),
    linear-gradient(180deg, #0f172a 0%, #0b1329 100%);
}

.dark .audit-sidebar .text-muted-foreground {
  color: #94a3b8 !important;
}

.dark .audit-sidebar .sidebar-nav-item {
  color: #cbd5e1;
}

.dark .audit-sidebar .sidebar-nav-item:hover {
  background: rgba(16, 185, 129, 0.12);
  color: #f8fafc;
}

.dark .audit-sidebar .sidebar-nav-item.active {
  color: #ffffff;
  background: rgba(16, 185, 129, 0.18);
}

.dark .sidebar-journey-progress {
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 52%, #a855f7 100%);
  box-shadow: 0 0 18px rgba(139, 92, 246, 0.38);
}

.dark .audit-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
}

.dark .audit-active-audit {
  background: rgba(15, 23, 42, 0.72);
  border-color: rgba(129, 140, 248, 0.28);
  color: #e2e8f0 !important;
}

.dark .audit-active-audit .text-foreground {
  color: #ffffff !important;
}

.dark .audit-active-audit .text-muted-foreground {
  color: #cbd5e1 !important;
}

.dark .audit-chat {
  border-left-color: rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, #111827 0%, #0f172a 100%);
}

.dark .audit-chat-panel {
  background: linear-gradient(180deg, #1c1f29 0%, #12151c 100%);
  color: #f8fafc;
}

.dark .audit-chat-panel .chat-header {
  background: rgba(15, 23, 42, 0.86);
  border-color: rgba(148, 163, 184, 0.2);
}

.dark .audit-chat-panel .chat-composer {
  background: rgba(15, 23, 42, 0.92);
  border-color: rgba(148, 163, 184, 0.2);
}

.dark .copilot-shell {
  background:
    radial-gradient(circle at top right, rgba(129, 140, 248, 0.12), transparent 28%),
    linear-gradient(180deg, #111827 0%, #0b1220 100%) !important;
  color: #e5e7eb;
}

.dark .copilot-header {
  padding: 16px 14px;
  background: rgba(15, 23, 42, 0.86) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.24);
}

.dark .copilot-title {
  color: #a5b4fc;
  font-size: clamp(0.95rem, 1.4vw, 1.125rem);
  line-height: 1.1;
  text-shadow: 0 0 18px rgba(129, 140, 248, 0.26);
}

.dark .copilot-context {
  color: #94a3b8;
  letter-spacing: 0.14em;
  line-height: 1.25;
}

.dark .copilot-avatar {
  border: 2px solid rgba(199, 210, 254, 0.86);
  box-shadow: 0 0 24px rgba(129, 140, 248, 0.24);
}

.dark .copilot-icon-btn {
  color: #a5b4fc !important;
  background: rgba(15, 23, 42, 0.44) !important;
  border: 1px solid rgba(129, 140, 248, 0.14);
}

.dark .copilot-icon-btn:hover {
  background: rgba(129, 140, 248, 0.16) !important;
color: #ddd6fe !important;
}

.dark .copilot-scroll {
  background:
    linear-gradient(90deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px),
    linear-gradient(180deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px);
  background-size: 44px 44px;
}

.dark .copilot-day-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.dark .copilot-day-divider::before,
.dark .copilot-day-divider::after {
  content: "";
  height: 1px;
  flex: 1 1;
  background: rgba(148, 163, 184, 0.14);
}

.dark .copilot-day-divider {
  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.dark .copilot-context-card {
  background: rgba(15, 23, 42, 0.54) !important;
  border-color: rgba(99, 102, 241, 0.24) !important;
  border-radius: 16px;
  min-width: 0;
  overflow: hidden;
}

.dark .copilot-welcome {
  background: linear-gradient(135deg, rgba(20, 184, 166, 0.18), rgba(99, 102, 241, 0.12)) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  min-width: 0;
  overflow: hidden;
}

.dark .copilot-welcome-actions > button {
  max-width: 100%;
  white-space: nowrap;
}

.dark .copilot-welcome .bg-primary {
  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
}

.dark .copilot-welcome .bg-primary:hover {
  background: linear-gradient(135deg, #818cf8, #a78bfa) !important;
}

.dark .copilot-bot-mark {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #eef2ff;
  box-shadow: 0 12px 26px rgba(79, 70, 229, 0.28);
  position: relative;
  overflow: hidden;
}

.dark .copilot-user-mark {
  background: rgba(20, 184, 166, 0.14);
  color: #99f6e4;
  border: 1px solid rgba(45, 212, 191, 0.18);
}

.dark .copilot-message-row {
  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--message-delay, 0ms);
}

.dark .message-user-row {
  transform-origin: right center;
}

.dark .message-assistant-row {
  transform-origin: left center;
}

.dark .copilot-message {
  border-radius: 20px;
  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.2);
  position: relative;
  overflow: hidden;
}

.dark .copilot-user-message {
  border-top-right-radius: 6px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);
  box-shadow: 0 16px 34px rgba(79, 70, 229, 0.26);
}

.dark .copilot-user-message::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);
  transform: translateX(-120%);
  animation: messageShimmer 4.2s ease-in-out infinite;
}

.dark .copilot-assistant-message {
  border-top-left-radius: 6px;
  background:
    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96)) !important;
  border-color: rgba(129, 140, 248, 0.18) !important;
}

.dark .copilot-assistant-message::before {
  content: "";
  position: absolute;
  inset: auto -20% 0 -20%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(45, 212, 191, 0.42) 50%, transparent 100%);
}

.dark .copilot-message-text {
  color: #e5e7eb;
}

.dark .copilot-message-text strong {
  color: #2dd4bf;
  font-weight: 800;
}

.dark .audit-chat-panel .quick-action {
  display: flex;
  min-height: 2.25rem;
  align-items: center;
  color: #e5e7eb !important;
  background: rgba(15, 23, 42, 0.72) !important;
  border-color: rgba(129, 140, 248, 0.18) !important;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
}

.dark .audit-chat-panel .quick-action:hover {
  background: rgba(20, 184, 166, 0.13) !important;
  border-color: rgba(45, 212, 191, 0.36) !important;
}

.dark .copilot-evidence-card {
  background: rgba(2, 6, 23, 0.22);
  border-radius: 12px;
  padding: 8px;
}

.dark .copilot-composer {
  background: rgba(15, 23, 42, 0.92) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
}

.dark .copilot-chip {
  border-color: rgba(129, 140, 248, 0.26) !important;
  background: rgba(15, 23, 42, 0.64) !important;
  color: #c7d2fe !important;
}

.dark .copilot-chip:hover {
  background: rgba(99, 102, 241, 0.18) !important;
}

.dark .copilot-input-shell {
  min-height: 56px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.9);
  padding: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 18px 36px rgba(2, 6, 23, 0.22);
}

.dark .copilot-input-icon {
  color: #94a3b8 !important;
}

.dark .copilot-input-icon:hover {
  color: #c7d2fe !important;
  background: rgba(129, 140, 248, 0.12) !important;
}

.dark .copilot-send {
  border-radius: 18px !important;
  background: linear-gradient(135deg, #c4b5fd, #6366f1) !important;
  color: #111827 !important;
  box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34);
  position: relative;
  overflow: hidden;
}

.dark .copilot-send:hover {
  background: linear-gradient(135deg, #ddd6fe, #818cf8) !important;
  transform: translateY(-1px);
}

.dark .copilot-send-armed {
  animation: sendPulse 1.6s ease-in-out infinite;
}

.dark .copilot-send-armed::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.36) 40%, transparent 70%);
  transform: translateX(-125%);
  animation: messageShimmer 2.8s ease-in-out infinite;
}

.dark .copilot-thinking-row {
  animation: phaseSectionIn 320ms ease both;
}

.dark .copilot-thinking-mark {
  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.08), 0 0 24px rgba(45, 212, 191, 0.22);
}

.dark .copilot-thinking-bubble {
  border-color: rgba(129, 140, 248, 0.24);
  background:
    radial-gradient(circle at top right, rgba(45, 212, 191, 0.12), transparent 35%),
    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96));
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.2);
}

.dark .copilot-typing-dots {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.dark .copilot-typing-dots span {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #2dd4bf, #a5b4fc);
  animation: typingBounce 0.95s ease-in-out infinite;
}

.dark .copilot-typing-dots span:nth-child(2) {
  animation-delay: 0.12s;
}

.dark .copilot-typing-dots span:nth-child(3) {
  animation-delay: 0.24s;
}

.dark .assistant-overlay {
  border-color: rgba(52, 211, 153, 0.24);
  background: linear-gradient(135deg, rgba(6, 95, 70, 0.34), rgba(27, 31, 40, 0.95));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dark .assistant-overlay-card {
  background: linear-gradient(145deg, rgba(28, 30, 39, 0.96), rgba(20, 22, 30, 0.98));
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);
}

.dark .assistant-task-track {
  background: rgba(16, 185, 129, 0.18);
}

.dark .quick-actions-item {
  border-color: rgba(52, 211, 153, 0.2);
  background: rgba(26, 28, 36, 0.88);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}

.dark .quick-actions-track {
  background: rgba(71, 85, 105, 0.45);
}

.dark .executive-glass {
  background: linear-gradient(140deg, rgba(33, 36, 46, 0.94), rgba(20, 23, 31, 0.88)) !important;
  border-color: rgba(52, 211, 153, 0.18) !important;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.dark .executive-hero {
  background: linear-gradient(120deg, #065f46 0%, #059669 40%, #0b1220 100%) !important;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);
}

.phase10-command-brief {
  background:
    radial-gradient(circle at top right, rgba(167, 243, 208, 0.28), transparent 32%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(236, 253, 245, 0.96) 55%, rgba(209, 250, 229, 0.92) 100%) !important;
  border: 1px solid rgba(5, 150, 105, 0.16) !important;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
}

.dark .phase10-command-brief {
  background:
    radial-gradient(circle at top right, rgba(52, 211, 153, 0.16), transparent 30%),
    linear-gradient(120deg, #0f172a 0%, #064e3b 45%, #0b1220 100%) !important;
  border: 1px solid rgba(52, 211, 153, 0.22) !important;
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.24);
}

.dark .hero-progress-wrap {
  background: rgba(17, 24, 39, 0.34);
  border-color: rgba(255, 234, 214, 0.12);
}

.hero-progress-wrap {
  background: rgba(255, 255, 255, 0.68);
  border-color: rgba(5, 150, 105, 0.16);
}

[data-testid="phase-10"] > div:first-child h2 {
  color: #ffffff !important;
  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.35);
}

[data-testid="phase-10"] > div:first-child p {
  color: #d1fae5 !important;
}

.dark .hero-progress-track {
  background: rgba(255, 245, 235, 0.1);
}

.dark .hero-progress-fill {
  background: linear-gradient(90deg, #fecaca, #fee2e2);
}

.dark .phase10-readable,
.dark .phase10-readable * {
  color: hsl(var(--foreground));
}

.dark .phase10-readable .phase10-print-preview,
.dark .phase10-readable .phase10-print-preview * {
  color: #111827 !important;
}

.dark .phase10-readable .phase10-print-preview .text-muted-foreground,
.dark .phase10-readable .phase10-print-preview [style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color:#6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color: #9ca3af"],
.dark .phase10-readable .phase10-print-preview [style*="color:#9ca3af"] {
  color: #4b5563 !important;
}

.dark .phase10-readable .phase10-print-preview [style*="color: #374151"],
.dark .phase10-readable .phase10-print-preview [style*="color:#374151"] {
  color: #374151 !important;
}

.dark .phase10-readable .phase10-print-preview h3,
.dark .phase10-readable .phase10-print-preview table,
.dark .phase10-readable .phase10-print-preview table td,
.dark .phase10-readable .phase10-print-preview table th,
.dark .phase10-readable .phase10-print-preview p,
.dark .phase10-readable .phase10-print-preview span,
.dark .phase10-readable .phase10-print-preview li {
  color: #111827 !important;
}

.dark .phase10-readable .phase10-print-preview table th,
.dark .phase10-readable .phase10-print-preview p[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview span[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview td[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color:#6b7280"] {
  color: #4b5563 !important;
}

.dark .phase10-readable .phase10-print-preview .phase10-finding-card,
.dark .phase10-readable .phase10-print-preview .phase10-finding-card * {
  color: #f8fafc !important;
}

.dark .phase10-readable .text-muted-foreground {
  color: #cbd5e1 !important;
}

.dark .phase10-readable .recharts-cartesian-axis-tick-value,
.dark .phase10-readable .recharts-polar-angle-axis text,
.dark .phase10-readable .recharts-polar-radius-axis text,
.dark .phase10-readable .recharts-tooltip-wrapper {
  fill: #cbd5e1;
  color: #cbd5e1;
}

.dark [data-testid="header"] {
  background: rgba(12, 18, 32, 0.94);
  border-bottom-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);
}

.dark [data-testid="header"] .header-audit-chip,
.dark [data-testid="header"] .header-search-results,
.dark [data-testid="header"] .header-date-pill,
.dark [data-testid="header"] .header-icon-btn {
  background: rgba(15, 23, 42, 0.78);
  border-color: rgba(129, 140, 248, 0.28);
  color: #e2e8f0;
}

.dark [data-testid="header"] .header-popover {
  background: #0f172a;
  border-color: rgba(129, 140, 248, 0.38);
  color: #f8fafc;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.dark [data-testid="header"] .header-popover > div:first-child {
  background: #111c33;
  border-bottom-color: rgba(129, 140, 248, 0.26);
}

.dark [data-testid="header"] .header-title {
  color: #f8fafc;
}

.dark [data-testid="header"] .header-subtitle,
.dark [data-testid="header"] .header-empty,
.dark [data-testid="header"] .header-item-sub {
  color: #cbd5e1;
}

.dark [data-testid="header"] .header-item:hover {
  background: rgba(99, 102, 241, 0.18);
}

.dark [data-testid="header"] .header-item-title,
.dark [data-testid="header"] .header-popover-title,
.dark [data-testid="header"] .header-date-pill {
  color: #f8fafc;
}

.dark [data-testid="header"] .header-item {
  color: #f1f5f9;
}

.header-date-pill,
.header-icon-btn,
.header-search-results,
.header-popover {
  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.header-search-results { animation-delay: 120ms; }
.header-date-pill { animation-delay: 180ms; }
.header-icon-btn { animation-delay: 220ms; }
.header-popover { animation-delay: 80ms; }

.audit-main .phase2-vscode-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #0f1117;
  color: #e5e7eb;
}

.audit-main .phase2-topbar {
  align-items: center;
  background: #e35d1f;
  color: #ffffff;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  min-height: 44px;
  padding: 0 14px;
}

.audit-main .phase2-menu {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  font-weight: 500;
  opacity: 0.96;
}

.audit-main .phase2-titlebar {
  align-items: center;
  display: flex;
  flex: 1 1;
  gap: 12px;
  justify-content: space-between;
  min-width: 0;
}

.audit-main .phase2-navcluster,
.audit-main .phase2-title-actions,
.audit-main .phase2-tabtools {
  align-items: center;
  display: flex;
  gap: 8px;
}

.audit-main .phase2-navbtn {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #ffffff;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.audit-main .phase2-projectpill {
  align-items: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  color: #ffffff;
  display: inline-flex;
  gap: 8px;
  height: 30px;
  max-width: 420px;
  min-width: 0;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
}

.audit-main .phase2-title-badge {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  color: #ffffff !important;
}

.audit-main .phase2-update-btn {
  background: linear-gradient(135deg, #5f87ff 0%, #426df5 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  height: 30px;
  padding: 0 14px;
}

.audit-main .phase2-tabbar {
  align-items: center;
  background: #0b0d12;
  border-bottom: 1px solid #252a36;
  display: flex;
  justify-content: space-between;
  min-height: 38px;
  padding: 0 10px;
}

.audit-main .phase2-tabs {
  display: flex;
  gap: 6px;
  overflow: auto;
}

.audit-main .phase2-tab {
  align-items: center;
  background: #131722;
  border: 1px solid transparent;
  border-bottom-color: #131722;
  border-radius: 8px 8px 0 0;
  color: #cbd5e1;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  height: 28px;
  padding: 0 12px;
  white-space: nowrap;
}

.audit-main .phase2-tab.is-active {
  background: #10141d;
  border-color: #2a303d;
  border-bottom-color: #10141d;
  color: #ffffff;
}

.audit-main .phase2-workspace {
  display: grid;
  flex: 1 1;
  gap: 0;
  grid-template-columns: 280px minmax(0, 1fr) 340px;
  min-height: 0;
  overflow: hidden;
  background: #10131a;
}

.audit-main .phase2-sidebar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.audit-main .phase2-chatpane {
  background: #11131a;
  border-right: 1px solid #242836;
}

.audit-main .phase2-sourcepane {
  background: #11131a;
  border-left: 1px solid #242836;
}

.audit-main .phase2-sidebar-head {
  align-items: flex-start;
  border-bottom: 1px solid #242836;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 12px;
}

.audit-main .phase2-sidebar-kicker {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.audit-main .phase2-sidebar-head h2 {
  color: #f8fafc;
  font-size: 14px;
  font-weight: 700;
  margin-top: 2px;
}

.audit-main .phase2-sidebar-actions {
  align-items: center;
  display: flex;
  gap: 6px;
}

.audit-main .phase2-notes {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
}

.audit-main .phase2-note {
  align-items: flex-start;
  color: #cbd5e1;
  display: flex;
  gap: 10px;
  font-size: 12px;
  line-height: 1.5;
}

.audit-main .phase2-note.is-title {
  color: #f8fafc;
  font-weight: 700;
}

.audit-main .phase2-note-dot {
  background: #94a3b8;
  border-radius: 999px;
  flex-shrink: 0;
  height: 6px;
  margin-top: 7px;
  width: 6px;
}

.audit-main .phase2-composer {
  margin-top: auto;
  padding: 14px;
  border-top: 1px solid #242836;
}

.audit-main .phase2-composer-head {
  display: flex;
  justify-content: space-between;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 8px;
}

.audit-main .phase2-composer-box {
  background: #0c1117;
  border: 1px solid #2a303d;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.audit-main .phase2-composer-input {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #e5e7eb !important;
  height: 34px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.audit-main .phase2-composer-input::placeholder {
  color: #94a3b8;
}

.audit-main .phase2-composer-actions {
  align-items: center;
  display: flex;
  gap: 8px;
}

.audit-main .phase2-miniicon {
  color: #cbd5e1;
  font-size: 14px;
  line-height: 1;
}

.audit-main .phase2-smallbtn {
  align-items: center;
  background: #151922;
  border: 1px solid #2a303d;
  border-radius: 8px;
  color: #cbd5e1;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.audit-main .phase2-sendbtn {
  align-items: center;
  background: #e5e7eb;
  border-radius: 999px;
  color: #0f172a;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  margin-left: auto;
  width: 32px;
}

.audit-main .phase2-composer-meta {
  color: #94a3b8;
  font-size: 11px;
  margin-top: 8px;
  text-align: right;
}

.audit-main .phase2-editor {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow: hidden;
  padding: 14px;
}

.audit-main .phase2-editor-head {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.audit-main .phase2-editor-path {
  color: #94a3b8;
  font-size: 11px;
  letter-spacing: 0.04em;
}

.audit-main .phase2-editor-head h1 {
  color: #f8fafc;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin-top: 4px;
}

.audit-main .phase2-editor-state {
  align-items: center;
  background: #11161f;
  border: 1px solid #2a303d;
  border-radius: 999px;
  color: #cbd5e1;
  display: flex;
  gap: 8px;
  font-size: 12px;
  padding: 6px 10px;
}

.audit-main .phase2-state-dot {
  background: #22c55e;
  border-radius: 999px;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.14);
  flex-shrink: 0;
  height: 8px;
  width: 8px;
}

.audit-main .phase2-editor-card,
.audit-main .phase2-terminalpanel {
  background: #121722 !important;
  border: 1px solid #2a303d !important;
  border-radius: 20px;
  box-shadow: none;
  overflow: hidden;
}

.audit-main .phase2-editor-card {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
}

.audit-main .phase2-editor-cardhead {
  padding: 14px 16px 4px;
}

.audit-main .phase2-editor-title {
  color: #f8fafc;
  font-size: 14px;
  font-weight: 700;
}

.audit-main .phase2-editor-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  overflow: hidden;
  padding: 8px 16px 16px;
}

.audit-main .phase2-commandrow {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}

.audit-main .phase2-commandlabel {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.audit-main .phase2-select {
  background: #0f141d !important;
  border: 1px solid #2a303d !important;
  color: #e5e7eb !important;
  height: 40px;
}

.audit-main .phase2-uploadbtn {
  align-items: center;
  background: #0f141d;
  border: 1px dashed #475569;
  border-radius: 12px;
  color: #e5e7eb;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 40px;
  justify-content: center;
}

.audit-main .phase2-helptext {
  color: #94a3b8;
  font-size: 11px;
  margin-top: 6px;
  text-align: center;
}

.audit-main .phase2-console {
  background: #0b0f16;
  border: 1px solid #242836;
  border-radius: 16px;
  padding: 12px;
}

.audit-main .phase2-console-head {
  color: #cbd5e1;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 11px;
  margin-bottom: 8px;
}

.audit-main .phase2-console-title {
  color: #f8fafc;
  font-weight: 700;
}

.audit-main .phase2-console-body {
  color: #cbd5e1;
  display: grid;
  font-size: 12px;
  gap: 8px 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.audit-main .phase2-console-key {
  color: #94a3b8;
  font-size: 10px;
  letter-spacing: 0.08em;
  margin-right: 8px;
  text-transform: uppercase;
}

.audit-main .phase2-console-value {
  color: #e5e7eb;
  font-weight: 600;
}

.audit-main .phase2-inlineactions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: auto;
}

.audit-main .phase2-actionbtn {
  background: #151922 !important;
  border: 1px solid #2a303d !important;
  color: #e5e7eb !important;
  height: 38px;
}

.audit-main .phase2-primarybtn {
  background: linear-gradient(135deg, #4f7cff 0%, #3b67f6 100%) !important;
  border: none !important;
  color: #ffffff !important;
  height: 38px;
  box-shadow: none;
}

.audit-main .phase2-terminalhead {
  padding: 12px 16px 0;
}

.audit-main .phase2-terminaltitle {
  align-items: center;
  color: #f8fafc;
  display: flex;
  gap: 8px;
  font-size: 13px;
}

.audit-main .phase2-terminalcontent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 14px;
}

.audit-main .phase2-terminalline {
  align-items: center;
  color: #cbd5e1;
  display: flex;
  gap: 8px;
  font-size: 12px;
}

.audit-main .phase2-terminalline svg {
  color: #4f7cff;
}

.audit-main .phase2-sourceactions {
  display: flex;
  justify-content: stretch;
  padding: 12px 14px 0;
}

.audit-main .phase2-commitbtn {
  background: #4f7cff !important;
  border: none !important;
  color: #fff !important;
  height: 36px;
  width: 100%;
}

.audit-main .phase2-sourcefeed {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px;
}

.audit-main .phase2-sourceitem {
  background: #0c1117;
  border: 1px solid #242836;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}

.audit-main .phase2-sourceitem.is-bad {
  background: rgba(127, 29, 29, 0.16);
  border-color: rgba(239, 68, 68, 0.45);
}

.audit-main .phase2-sourceitem-top {
  align-items: center;
  display: flex;
  gap: 8px;
  min-width: 0;
}

.audit-main .phase2-source-dot {
  border-radius: 999px;
  flex-shrink: 0;
  height: 8px;
  width: 8px;
}

.audit-main .phase2-source-name {
  color: #f8fafc;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audit-main .phase2-sourceitem-meta {
  color: #94a3b8;
  display: flex;
  font-size: 10px;
  gap: 8px;
  justify-content: space-between;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.audit-main .phase2-sourceitem-actions {
  align-items: center;
  display: flex;
  gap: 8px;
}

.audit-main .phase2-source-input {
  background: #151922;
  border: 1px solid #2a303d;
  border-radius: 10px;
  color: #e5e7eb;
  flex: 1 1;
  font-size: 12px;
  height: 32px;
  padding: 0 10px;
}

.audit-main .phase2-source-delete {
  align-items: center;
  background: #1a1113;
  border: 1px solid #39242a;
  border-radius: 10px;
  color: #fca5a5;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.audit-main .phase2-emptyfeed {
  align-items: center;
  background: #0c1117;
  border: 1px dashed #2a303d;
  border-radius: 16px;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 120px;
  justify-content: center;
}

.audit-main .phase2-sourcefooter {
  color: #94a3b8;
  font-size: 11px;
  padding: 0 14px 14px;
  text-align: center;
}

.audit-main .phase2-readybadge {
  background: rgba(34, 197, 94, 0.14) !important;
  border: 1px solid rgba(34, 197, 94, 0.28) !important;
  color: #86efac !important;
}

.dark [data-testid="login-page"] .login-shell {
  background: rgba(17, 20, 29, 0.78);
  border-color: rgba(59, 130, 246, 0.12);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.28);
}

.dark [data-testid="login-page"] .login-panel {
  background: rgba(20, 24, 33, 0.92);
}

.dark [data-testid="login-page"] .login-title {
  color: #f8fafc;
}

.dark [data-testid="login-page"] .login-copy {
  color: #94a3b8;
}

.dark [data-testid="login-page"] .login-card {
  background: rgba(23, 27, 37, 0.92);
  border-color: rgba(255, 255, 255, 0.08);
}

.dark .audit-layout {
  background: #080a0f;
  color: #e5e7eb;
}

.dark .audit-sidebar,
.dark [data-testid="sidebar"] {
  background: #0f1117 !important;
  border-color: #252a36 !important;
  color: #d1d5db !important;
}

.dark [data-testid="sidebar"] .audit-brand,
.dark [data-testid="sidebar"] .audit-panel,
.dark [data-testid="sidebar"] > div:last-child {
  background: #0f1117 !important;
  border-color: #252a36 !important;
}

.dark [data-testid="sidebar"] .audit-panel {
  background: #151922 !important;
}

.audit-main .phase2-page {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  padding: 18px 20px 16px;
  background:
    radial-gradient(circle at top left, rgba(34, 197, 94, 0.08), transparent 22%),
    radial-gradient(circle at top right, rgba(14, 165, 233, 0.06), transparent 18%),
    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  color: #0f172a;
}

.audit-main .phase2-hero {
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e2e8f0;
  border-radius: 26px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
  display: grid;
  gap: 18px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 18px 22px;
}

.audit-main .phase2-hero-mark {
  align-items: center;
  background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #bbf7d0;
  border-radius: 18px;
  color: #16a34a;
  display: grid;
  height: 58px;
  place-items: center;
  width: 58px;
}

.audit-main .phase2-hero-icon {
  height: 28px;
  width: 28px;
}

.audit-main .phase2-hero-copy {
  min-width: 0;
}

.audit-main .phase2-hero-copy h1 {
  color: #0f172a;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.audit-main .phase2-hero-copy p {
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
  margin-top: 4px;
}

.audit-main .phase2-hero-actions {
  align-items: center;
  display: flex;
  gap: 10px;
}

.audit-main .phase2-iconbtn {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 14px !important;
  color: #334155 !important;
  height: 44px;
  width: 44px;
}

.audit-main .phase2-primarybtn {
  align-items: center;
  background: linear-gradient(135deg, #1f9d57 0%, #15924e 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  box-shadow: 0 14px 30px rgba(21, 146, 78, 0.22);
  color: #ffffff !important;
  display: inline-flex;
  gap: 8px;
  height: 44px;
  padding: 0 18px;
}

.audit-main .phase2-upload-card {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dbeadf;
  border-radius: 24px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.05);
}

.audit-main .phase2-upload-content {
  padding: 18px 22px 20px;
}

.audit-main .phase2-upload-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: minmax(260px, 0.86fr) minmax(0, 1.14fr);
}

.audit-main .phase2-field-label {
  color: #1e293b;
  display: block;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.audit-main .phase2-select {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 14px !important;
  color: #0f172a !important;
  height: 48px;
}

.audit-main .phase2-dropzone {
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px dashed #cdd7e3;
  border-radius: 16px;
  color: #334155;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  min-height: 98px;
  text-align: center;
}

.audit-main .phase2-dropzone strong {
  color: #16a34a;
}

.audit-main .phase2-dropzone small {
  color: #64748b;
  font-size: 12px;
}

.audit-main .phase2-dropzone-status {
  align-items: center;
  color: #15803d;
  display: inline-flex;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
}

.audit-main .phase2-docs-card {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.05);
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.audit-main .phase2-docs-header {
  align-items: center;
  border-bottom: 1px solid #edf2f7;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(0, 1fr) auto auto;
  padding: 16px 20px 14px;
}

.audit-main .phase2-docs-heading {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.audit-main .phase2-docs-title {
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.audit-main .phase2-status-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.audit-main .phase2-pill {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 999px;
  color: #334155 !important;
  display: inline-flex;
  gap: 8px;
  height: 30px;
  padding: 0 12px;
}

.audit-main .phase2-pill-ready {
  background: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
  color: #15803d !important;
}

.audit-main .phase2-pill-processing {
  background: #eff6ff !important;
  border-color: #bfdbfe !important;
  color: #2563eb !important;
}

.audit-main .phase2-pill-failed {
  background: #fef2f2 !important;
  border-color: #fecaca !important;
  color: #ef4444 !important;
}

.audit-main .phase2-pill-dot {
  background: currentColor;
  border-radius: 999px;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.audit-main .phase2-searchbox {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 14px;
  color: #64748b;
  display: flex;
  gap: 10px;
  height: 42px;
  min-width: 270px;
  padding: 0 14px;
}

.audit-main .phase2-searchinput {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  height: 40px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.audit-main .phase2-searchinput:focus {
  box-shadow: none !important;
}

.audit-main .phase2-filterbtn {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 14px !important;
  color: #334155 !important;
  height: 42px;
  padding: 0 14px;
}

.audit-main .phase2-docs-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 14px;
  min-height: 0;
  overflow: hidden;
  padding: 14px 20px 18px;
}

.audit-main .phase2-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: space-between;
}

.audit-main .phase2-toolbar-filters,
.audit-main .phase2-toolbar-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.audit-main .phase2-toolbar-select {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 12px !important;
  color: #0f172a !important;
  height: 40px;
  min-width: 158px;
}

.audit-main .phase2-toolbar-btn {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 12px !important;
  color: #334155 !important;
  height: 40px;
}

.audit-main .phase2-tablewrap {
  background: #ffffff;
  border: 1px solid #e8edf4;
  border-radius: 18px;
  flex: 1 1;
  min-height: 0;
  overflow: auto;
}

.audit-main .phase2-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}

.audit-main .phase2-table thead th {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 13px 14px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.audit-main .phase2-table tbody td {
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  padding: 12px 14px;
  vertical-align: middle;
}

.audit-main .phase2-col-check {
  width: 34px;
  text-align: center;
}

.audit-main .phase2-col-actions {
  width: 54px;
  text-align: right;
}

.audit-main .phase2-filecell {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.audit-main .phase2-fileicon {
  align-items: center;
  background: #ecfdf5;
  border: 1px solid #ccefd7;
  border-radius: 10px;
  color: #16a34a;
  display: inline-flex;
  flex-shrink: 0;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.audit-main .phase2-filename {
  color: #1e293b;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audit-main .phase2-type-badge {
  background: #eef2ff !important;
  border: 1px solid #ddd6fe !important;
  color: #6d28d9 !important;
  font-size: 11px;
  font-weight: 700;
}

.audit-main .phase2-classification-input {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 12px !important;
  color: #334155 !important;
  font-size: 12px;
  height: 36px;
  width: 100%;
}

.audit-main .phase2-status-cell {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
}

.audit-main .phase2-status-ready {
  color: #16a34a;
}

.audit-main .phase2-status-processing {
  color: #2563eb;
}

.audit-main .phase2-status-failed {
  color: #ef4444;
}

.audit-main .phase2-ready-dot {
  background: #16a34a;
  border-radius: 999px;
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.14);
  display: inline-block;
  flex-shrink: 0;
  height: 8px;
  width: 8px;
}

.audit-main .phase2-mono {
  color: #475569;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.audit-main .phase2-row-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #64748b;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  margin-left: auto;
  width: 30px;
}

.audit-main .phase2-row-failed td {
  background: rgba(254, 242, 242, 0.72);
}

.audit-main .phase2-emptytable {
  align-items: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-height: 112px;
}

.audit-main .phase2-footer {
  align-items: center;
  color: #64748b;
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr auto auto;
  font-size: 13px;
}

.audit-main .phase2-pagination {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
}

.audit-main .phase2-pagebtn {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  color: #64748b;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.audit-main .phase2-pagebtn.is-active {
  background: #16a34a;
  border-color: #16a34a;
  color: #ffffff;
}

.audit-main .phase2-pagegap {
  color: #cbd5e1;
}

.audit-main .phase2-rowsperpage {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.audit-main .phase2-rows-select {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 10px !important;
  color: #0f172a !important;
  height: 34px;
  min-width: 78px;
}

.audit-main .phase2-bottom-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.audit-main .phase2-savebtn {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 14px !important;
  color: #334155 !important;
  height: 44px;
  padding: 0 18px;
}

.audit-main .phase2-continue-bottom {
  min-width: 248px;
}

.audit-main .phase2-page .phase2-primarybtn:hover,
.audit-main .phase2-savebtn:hover,
.audit-main .phase2-iconbtn:hover,
.audit-main .phase2-toolbar-btn:hover,
.audit-main .phase2-filterbtn:hover,
.audit-main .phase2-row-action:hover,
.audit-main .phase2-pagebtn:hover {
  transform: translateY(-1px);
}


.dark [data-testid="sidebar"] p,
.dark [data-testid="sidebar"] span {
  color: inherit;
}

.dark [data-testid="sidebar"] .text-\\[\\#0a0a0a\\],
.dark [data-testid="sidebar"] .text-\\[\\#364153\\] {
  color: #e5e7eb !important;
}

.dark [data-testid="sidebar"] .text-\\[\\#6a7282\\],
.dark [data-testid="sidebar"] .text-muted-foreground {
  color: #94a3b8 !important;
}

.dark [data-testid="sidebar"] .sidebar-nav-item {
  color: #cbd5e1 !important;
}

.dark [data-testid="sidebar"] .sidebar-nav-item:hover {
  background: #1b202b !important;
}

.dark [data-testid="sidebar"] .sidebar-nav-item.active,
.dark [data-testid="sidebar"] .bg-\\[\\#bcbcbc\\] {
  background: #2a303d !important;
  color: #f8fafc !important;
}

.dark [data-testid="sidebar"] button[title="Refresh audit runs"] {
  background: #121722 !important;
  border-color: rgba(52, 211, 153, 0.34) !important;
  color: #f8fafc !important;
}

.dark .audit-header,
.dark [data-testid="header"] {
  background: rgba(15, 17, 23, 0.92) !important;
  border-bottom-color: #252a36 !important;
  color: #e5e7eb !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(16px);
}

.dark [data-testid="header"] .header-audit-chip,
.dark [data-testid="header"] .header-search-results,
.dark [data-testid="header"] .header-popover,
.dark [data-testid="header"] .header-date-pill,
.dark [data-testid="header"] .header-icon-btn,
.dark [data-testid="header"] .header-search-input,
.dark [data-testid="header"] .header-avatar,
.dark [data-testid="header"] input {
  background: #151922 !important;
  border-color: #2a303d !important;
  color: #e5e7eb !important;
}

.dark [data-testid="header"] input::placeholder {
  color: #94a3b8 !important;
}

.dark [data-testid="header"] svg {
  color: #94a3b8;
}

.dark .audit-main {
  background: #080a0f;
  box-shadow: inset -1px 0 0 #252a36;
}

.dark .audit-main::before {
  display: none;
}

.dark .audit-main .bg-card,
.dark .audit-main [class*="bg-card/"],
.dark .audit-main .bg-background,
.dark .audit-main .bg-white,
.dark .audit-main [class*="bg-white/"] {
  background-color: #151922 !important;
}

.dark .audit-main .border,
.dark .audit-main [class*="border-"] {
  border-color: #2a303d;
}

.dark .audit-main .text-slate-900,
.dark .audit-main .text-slate-800,
.dark .audit-main .text-slate-700,
.dark .audit-main .text-gray-900,
.dark .audit-main .text-gray-800,
.dark .audit-main .text-\\[\\#0a0a0a\\],
.dark .audit-main .text-\\[\\#364153\\],
.dark .audit-main .text-\\[\\#4a5565\\] {
  color: #f8fafc !important;
}

.dark .audit-main .text-muted-foreground,
.dark .audit-main .text-slate-600,
.dark .audit-main .text-slate-500,
.dark .audit-main .text-gray-500,
.dark .audit-main .text-\\[\\#6a7282\\],
.dark .audit-main .text-\\[\\#94a3b8\\] {
  color: #94a3b8 !important;
}

.dark .audit-main input,
.dark .audit-main textarea,
.dark .audit-main button[role="combobox"] {
  background: #10141d !important;
  border-color: #2a303d !important;
  color: #f8fafc !important;
}

.dark .audit-chat,
.dark .audit-chat-panel,
.dark .audit-chat-panel .chat-header,
.dark .audit-chat-panel .chat-composer {
  background: #0f1117 !important;
  border-color: #252a36 !important;
  color: #e5e7eb !important;
}

.dark .audit-chat-panel p,
.dark .audit-chat-panel span,
.dark .audit-chat-panel .text-\\[\\#0a0a0a\\],
.dark .audit-chat-panel .text-\\[\\#4a5565\\],
.dark .audit-chat-panel .text-black {
  color: #e5e7eb !important;
}

.dark .audit-chat-panel .text-\\[\\#6a7282\\],
.dark .audit-chat-panel .text-muted-foreground {
  color: #94a3b8 !important;
}

.dark .audit-chat-panel input,
.dark .audit-chat-panel .chat-composer button {
  background: #151922 !important;
  border-color: #3b4251 !important;
  color: #e5e7eb !important;
}

.audit-main .phase1-figma {
  color: #0f172a;
}

.audit-main .phase1-shell {
  max-width: none;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 18px 20px 16px;
}

.audit-main .phase1-fit {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
}

.audit-main .phase1-top-card {
  align-items: center;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 24px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);
  display: flex;
  gap: 24px;
  justify-content: flex-start;
  margin-bottom: 0;
  padding: 16px 20px;
}

.audit-main .phase1-title-block {
  align-items: center;
  display: flex;
  gap: 16px;
  min-width: 0;
  width: 100%;
}

.audit-main .phase1-hero-badge {
  align-items: center;
  background: linear-gradient(135deg, #1f9d5a 0%, #0f8a49 100%);
  border-radius: 999px;
  box-shadow: 0 10px 20px rgba(15, 138, 73, 0.16);
  display: flex;
  flex-shrink: 0;
  height: 52px;
  justify-content: center;
  width: 52px;
}

.audit-main .phase1-hero-badge-num {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.audit-main .phase1-title-copy {
  min-width: 0;
}

.audit-main .phase1-title-copy h1 {
  color: #1e293b;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.audit-main .phase1-title-copy p {
  color: #64748b;
  font-size: 13px;
  line-height: 1.45;
  margin-top: 8px;
  max-width: 800px;
}

.audit-main .phase1-empty-state {
  display: flex;
  justify-content: center;
  padding: 10px 0 0;
}

.audit-main .phase1-empty-card {
  background: #ffffff !important;
  border: 1px solid rgba(148, 163, 184, 0.16) !important;
  border-radius: 24px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);
  max-width: 520px;
  width: 100%;
}

.audit-main .phase1-empty-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 24px 24px 22px;
  text-align: center;
}

.audit-main .phase1-empty-icon {
  align-items: center;
  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 22px;
  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.12);
  display: flex;
  height: 64px;
  justify-content: center;
  margin-bottom: 14px;
  width: 64px;
}

.audit-main .phase1-empty-content h2 {
  color: #1e293b;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.audit-main .phase1-empty-content p {
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
  margin-top: 6px;
}

.audit-main .phase1-panel {
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(148, 163, 184, 0.16) !important;
  border-radius: 24px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.audit-main .phase1-card-header {
  padding: 14px 18px 4px;
}

.audit-main .phase1-card-title {
  color: #0f172a;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.audit-main .phase1-card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 10px;
  min-height: 0;
  overflow: hidden;
  padding: 2px 18px 14px;
}

.audit-main .phase1-label {
  color: #1e293b;
  font-size: 12px;
  font-weight: 600;
}

.audit-main .phase1-input,
.audit-main .phase1-select {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  color: #0f172a !important;
  color-scheme: light;
  height: 40px;
}

.audit-main .phase1-input::placeholder {
  color: #94a3b8;
}

.audit-main .phase1-input:focus-visible,
.audit-main .phase1-select:focus-visible {
  box-shadow: 0 0 0 3px rgba(31, 157, 90, 0.16);
  outline: none;
}

.audit-main .phase1-domain-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.audit-main .phase1-domain-btn,
.audit-main .phase1-chip,
.audit-main .phase1-badge,
.audit-main .phase1-outline-btn {
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.audit-main .phase1-domain-btn {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d9e1ec;
  border-radius: 16px;
  color: #334155;
  display: flex;
  gap: 12px;
  min-height: 42px;
  padding: 10px 12px;
  position: relative;
}

.audit-main .phase1-domain-icon {
  align-items: center;
  color: #334155;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
}

.audit-main .phase1-domain-label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  text-align: left;
}

.audit-main .phase1-domain-check {
  color: #1f9d5a;
  margin-left: auto;
}

.audit-main .phase1-domain-btn:hover,
.audit-main .phase1-chip:hover,
.audit-main .phase1-badge:hover,
.audit-main .phase1-outline-btn:hover {
  transform: translateY(-1px);
}

.audit-main .phase1-domain-btn.is-active {
  background: #f4fbf7;
  border-color: #1f9d5a;
  box-shadow: inset 0 0 0 1px rgba(31, 157, 90, 0.08);
  color: #0f7a43;
}

.audit-main .phase1-domain-btn.is-active .phase1-domain-icon {
  color: #0f7a43;
}

.audit-main .phase1-banner {
  align-items: flex-start;
  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);
  border: 1px solid #dbeafe;
  border-radius: 14px;
  color: #35506b;
  display: flex;
  gap: 12px;
  padding: 8px 10px;
}

.audit-main .phase1-banner-icon {
  align-items: center;
  background: #2563eb;
  border-radius: 999px;
  color: #ffffff;
  display: flex;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 700;
  height: 20px;
  justify-content: center;
  line-height: 1;
  margin-top: 2px;
  width: 20px;
}

.audit-main .phase1-banner p {
  font-size: 13px;
  line-height: 1.55;
  margin: 0;
}

.audit-main .phase1-grid-two {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.audit-main .phase1-grid-three {
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.8fr);
}

.audit-main .phase1-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.audit-main .phase1-input-shell {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 14px;
  display: flex;
  gap: 10px;
  min-height: 40px;
  padding: 0 12px;
}

.audit-main .phase1-input-shell .phase1-input-with-icon {
  border: 0 !important;
  box-shadow: none !important;
  flex: 1 1;
  height: 38px;
  padding-left: 0;
  padding-right: 0;
}

.audit-main .phase1-field-icon,
.audit-main .phase1-field-chevron {
  color: #64748b;
  flex-shrink: 0;
}

.audit-main .phase1-chip-cloud,
.audit-main .phase1-chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.audit-main .phase1-chip,
.audit-main .phase1-badge {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe3ee !important;
  border-radius: 999px;
  color: #334155;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  gap: 6px;
  min-height: 30px;
  padding: 5px 10px;
}

.audit-main .phase1-chip.is-active,
.audit-main .phase1-badge.is-active {
  background: #eaf9f0;
  border-color: #1f9d5a !important;
  color: #0f7a43;
}

.audit-main .phase1-inline-add {
  display: flex;
  gap: 6px;
}

.audit-main .phase1-inline-input {
  flex: 1 1;
  height: 36px;
}

.audit-main .phase1-add-btn,
.audit-main .phase1-secondary-btn {
  flex-shrink: 0;
  min-width: 78px;
}

.audit-main .phase1-helper {
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

.audit-main .phase1-text-link {
  color: #1f9d5a;
  font-size: 11px;
  font-weight: 600;
  text-align: left;
}

.audit-main .phase1-recommendation span {
  color: #1f9d5a;
  font-weight: 700;
}

.audit-main .phase1-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 0;
}

.audit-main .phase1-primary-btn {
  background: linear-gradient(135deg, #24a35a 0%, #15803d 100%) !important;
  border: 1px solid #15803d !important;
  box-shadow: 0 14px 28px rgba(21, 128, 61, 0.18);
  color: #ffffff !important;
  min-width: 164px;
}

.audit-main .phase1-primary-btn:hover {
  background: linear-gradient(135deg, #2fb165 0%, #166534 100%) !important;
  color: #ffffff !important;
}

.audit-main .phase1-outline-btn {
  background: #ffffff !important;
  border: 1px solid #dbe3ee !important;
  color: #334155;
}

.audit-main .phase1-secondary-btn {
  min-width: 120px;
}

.audit-main .phase1-outline-btn:hover {
  background: #f8fbff !important;
  border-color: #cbd5e1 !important;
}

.dark .audit-main .phase1-figma {
  color: #e5e7eb;
}

.dark .audit-main .phase1-top-card,
.dark .audit-main .phase1-panel,
.dark .audit-main .phase1-empty-card {
  background: rgba(17, 24, 39, 0.9) !important;
  border-color: rgba(148, 163, 184, 0.16) !important;
}

.dark .audit-main .phase1-title-copy h1,
.dark .audit-main .phase1-card-title,
.dark .audit-main .phase1-label,
.dark .audit-main .phase1-empty-content h2 {
  color: #f8fafc;
}

.dark .audit-main .phase1-title-copy p,
.dark .audit-main .phase1-helper,
.dark .audit-main .phase1-empty-content p,
.dark .audit-main .phase1-banner p,
.dark .audit-main .phase1-domain-label {
  color: #cbd5e1;
}

.dark .audit-main .phase1-stepper-dot,
.dark .audit-main .phase1-domain-btn,
.dark .audit-main .phase1-chip,
.dark .audit-main .phase1-badge,
.dark .audit-main .phase1-input,
.dark .audit-main .phase1-select,
.dark .audit-main .phase1-input-shell,
.dark .audit-main .phase1-outline-btn {
  background: #0f172a !important;
  border-color: #243246 !important;
  color: #e5e7eb !important;
}

.dark .audit-main .phase1-stepper-line {
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.45), rgba(148, 163, 184, 0.12));
}

.dark .audit-main .phase1-banner {
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.92) 0%, rgba(15, 23, 42, 0.98) 100%);
  border-color: rgba(59, 130, 246, 0.22);
}

.dark .audit-main .phase1-domain-btn.is-active {
  background: rgba(15, 118, 67, 0.22);
  border-color: rgba(34, 197, 94, 0.55);
  color: #ecfdf5;
}

.dark .audit-main .phase1-chip.is-active,
.dark .audit-main .phase1-badge.is-active {
  background: rgba(15, 118, 67, 0.22);
  border-color: rgba(34, 197, 94, 0.55) !important;
  color: #ecfdf5;
}

.dark .audit-main .phase1-primary-btn {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
  border-color: #16a34a !important;
}

.audit-main .connections-page {
  color: #0a0a0a;
}

.audit-main .connections-title {
  color: #0a0a0a;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.0703px;
  line-height: 32px;
}

.audit-main .connections-subtitle,
.audit-main .connections-card-subtitle {
  color: #4a5565;
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
}

.audit-main .connections-card {
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 14px;
  box-shadow: none;
}

.audit-main .connections-card-header {
  padding: 20px 20px 12px;
}

.audit-main .connections-card-title {
  color: #0a0a0a;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.4395px;
  line-height: 28px;
}

.audit-main .connections-card-content {
  padding: 0 20px 20px;
}

.audit-main .connections-stat-card {
  height: 76px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 14px;
  background: linear-gradient(162.55deg, #f3f4f6 0%, #e5e7eb 100%) !important;
  color: #364153;
  box-shadow: none;
}

.audit-main .connections-stat-card.is-red,
.audit-main .connections-stat-card.is-dark {
  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;
  color: #ffffff;
}

.audit-main .connections-stat-value {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.3955px;
  line-height: 36px;
}

.audit-main .connections-stat-label {
  font-size: 14px;
  line-height: 20px;
  opacity: 0.9;
}

.audit-main .connections-stat-icon {
  align-items: center;
  background: #d1d5dc;
  border-radius: 9999px;
  color: #364153;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.audit-main .connections-stat-card.is-red .connections-stat-icon,
.audit-main .connections-stat-card.is-dark .connections-stat-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.dark .audit-main .connections-page,
.dark .audit-main .connections-title,
.dark .audit-main .connections-card-title {
  color: #f8fafc !important;
}

.dark .audit-main .connections-subtitle,
.dark .audit-main .connections-card-subtitle {
  color: #94a3b8 !important;
}

.dark .audit-main .connections-card {
  background: #151922 !important;
  border-color: #2a303d !important;
}

.dark .audit-main .connections-stat-card {
  border-color: #2a303d !important;
  background: linear-gradient(162.55deg, #1b202b 0%, #252a36 100%) !important;
  color: #cbd5e1;
}

.dark .audit-main .connections-stat-card.is-red,
.dark .audit-main .connections-stat-card.is-dark {
  background: linear-gradient(162.55deg, #050506 0%, #7f0505 100%) !important;
  color: #ffffff;
}

.dark .audit-main .connections-stat-icon {
  background: #2a303d;
  color: #cbd5e1;
}

.audit-main .user-page {
  color: #0a0a0a;
}

.audit-main .user-role-card {
  height: 76px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 14px;
  background: linear-gradient(162.55deg, #f3f4f6 0%, #e5e7eb 100%) !important;
  color: #364153;
  box-shadow: none;
}

.audit-main .user-role-card.is-highlighted {
  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;
  color: #ffffff;
}

.audit-main .user-role-card:nth-child(2).is-highlighted {
  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;
}

.audit-main .user-role-card:nth-child(3).is-highlighted,
.audit-main .user-role-card:nth-child(5).is-highlighted {
  background: linear-gradient(162.55deg, #bb0000 0%, #000000 100%) !important;
}

.audit-main .user-role-icon {
  align-items: center;
  background: #d1d5dc;
  border-radius: 9999px;
  color: #364153;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.audit-main .user-role-card.is-highlighted .user-role-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.audit-main .user-table-card {
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 14px;
  background: #ffffff !important;
  box-shadow: none;
}

.audit-main .user-table {
  overflow: hidden;
  border-radius: 14px;
}

.audit-main .user-table th {
  height: 38px;
  color: #4a5565;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.1504px;
  line-height: 20px;
  text-transform: uppercase;
}

.audit-main .user-table td {
  height: 46px;
  color: #4a5565;
  font-size: 14px;
  letter-spacing: -0.1504px;
  line-height: 20px;
}

.audit-main .user-table tr {
  border-color: #f3f4f6;
}

.audit-main .user-role-badge,
.audit-main .user-status-badge {
  align-items: center;
  border-radius: 8px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  height: 22px;
  line-height: 16px;
  padding: 3px 9px;
  text-transform: none;
}

.audit-main .user-status-badge.is-active {
  background: #dcfce7;
  border-color: transparent;
  color: #008236;
}

.audit-main .user-status-badge.is-disabled {
  background: #fee2e2;
  border-color: transparent;
  color: #dc2626;
}

.dark .audit-main .user-page {
  color: #f8fafc;
}

.dark .audit-main .user-page h2,
.dark .audit-main .user-table-card [class*="CardTitle"],
.dark .audit-main .user-table td:first-child {
  color: #f8fafc !important;
}

.dark .audit-main .user-role-card {
  border-color: #2a303d !important;
  background: linear-gradient(162.55deg, #1b202b 0%, #252a36 100%) !important;
  color: #cbd5e1;
}

.dark .audit-main .user-role-card.is-highlighted {
  background: linear-gradient(162.55deg, #050506 0%, #7f0505 100%) !important;
  color: #ffffff;
}

.dark .audit-main .user-table-card {
  background: #151922 !important;
  border-color: #2a303d !important;
}

.dark .audit-main .user-table th,
.dark .audit-main .user-table td {
  color: #cbd5e1 !important;
}

.dark .audit-main .user-table tr {
  border-color: #252a36;
}

.dark .audit-main .user-role-icon {
  background: #2a303d;
  color: #cbd5e1;
}

.dark .audit-main .user-role-card.is-highlighted .user-role-icon {
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
}

.ai-sparkle {
  animation: sparkleSpin 2.6s linear infinite;
}

.heatmap-threshold-bg {
  background:
    linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(220, 38, 38, 0.12) 48%, rgba(239, 68, 68, 0.12) 100%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(254, 242, 242, 0.45));
  border: 1px solid rgba(254, 202, 202, 0.65);
}

.quick-actions-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quick-actions-item {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(254, 202, 202, 0.7);
  background: rgba(255, 250, 250, 0.9);
  border-radius: 14px;
  padding: 8px;
  animation: rowIn 420ms ease both;
  animation-delay: var(--qa-delay, 0ms);
  transition: transform 170ms ease, box-shadow 170ms ease;
}

.quick-actions-item:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
}

.quick-actions-track {
  height: 6px;
  border-radius: 999px;
  margin-top: 6px;
  background: #e2e8f0;
  overflow: hidden;
}

.quick-actions-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #b91c1c, #ef4444);
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.agent-scanning {
  letter-spacing: 0.02em;
}

.assistant-overlay {
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(254, 242, 242, 0.97), rgba(255, 250, 250, 0.96));
  padding: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.assistant-task-row {
  animation: rowIn 420ms ease both;
  animation-delay: var(--task-delay, 0ms);
}

.assistant-task-track {
  height: 5px;
  border-radius: 999px;
  background: #fecaca;
  overflow: hidden;
  margin-top: 4px;
}

.assistant-task-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #b91c1c, #ef4444);
  animation: progressGrow 800ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.assistant-overlay-card {
  background: linear-gradient(145deg, rgba(255, 250, 250, 0.95), rgba(254, 242, 242, 0.98));
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.typing-dots::after {
  content: "...";
  display: inline-block;
  width: 12px;
  overflow: hidden;
  vertical-align: bottom;
  animation: typingDots 1.1s steps(4, end) infinite;
}

/* Keyframes */
@keyframes orbFloat {
  from { transform: translateY(-8px) scale(1); }
  to { transform: translateY(10px) scale(1.05); }
}

@keyframes particlesDrift {
  from { transform: translateY(0); }
  to { transform: translateY(-20px); }
}

@keyframes navItemIn {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes sidebarIn {
  from { opacity: 0; transform: translateX(-16px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes metricIn {
  from { opacity: 0; transform: translateY(18px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes rowIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes progressGrow {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

@keyframes phasePageIn {
  from { opacity: 0; transform: translateY(18px) scale(0.99); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes phaseSectionIn {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes phaseDotIn {
  from { opacity: 0; transform: scale(0.82); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes currentPhasePulse {
  0%, 100% {
    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);
  }
  50% {
    box-shadow: 0 0 0 9px rgba(99, 102, 241, 0.08), 0 0 28px rgba(45, 212, 191, 0.24);
  }
}

@keyframes heroGradientDrift {
  from { background-position: 0% 0%, 0% 0%, 0% 0%; }
  to { background-position: 5% 8%, -4% 4%, 100% 100%; }
}

@keyframes messageSlideIn {
  from { opacity: 0; transform: translateY(18px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes messageShimmer {
  0% { transform: translateX(-125%); }
  45%, 100% { transform: translateX(125%); }
}

@keyframes typingBounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }
  40% { transform: translateY(-4px); opacity: 1; }
}

@keyframes sendPulse {
  0%, 100% { box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34); }
  50% { box-shadow: 0 16px 36px rgba(45, 212, 191, 0.26); }
}

@keyframes scanSweep {
  0% { transform: translateX(-120%); }
  55%, 100% { transform: translateX(120%); }
}

@keyframes bellPulse {
  0%, 100% { opacity: 0.9; transform: scale(1); }
  50% { opacity: 0.45; transform: scale(0.84); }
}

@keyframes floatBtnIn {
  from { opacity: 0; transform: translateY(24px) scale(0.92); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes sparkleSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes typingDots {
  0% { width: 0; }
  100% { width: 12px; }
}

@keyframes healthPulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color, rgba(148, 163, 184, 0.4));
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 7px transparent;
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ambient-orb,
  .ambient-particles,
  .sidebar-nav-item,
  .metric-card-anim,
  .table-row-anim,
  .progress-anim,
  .notification-pulse,
  .floating-ai-btn,
  .ai-sparkle,
  .phase-step-dot,
  .phase-step-line::after,
  [data-testid^="phase-"],
  [data-testid^="phase-"] > *,
  .phase7-hero,
  .phase7-console-card,
  .phase7-control-row,
  .phase7-progress-card,
  .header-date-pill,
  .header-icon-btn,
  .header-search-results,
  .header-popover,
  .audit-card,
  .copilot-message-row,
  .copilot-user-message::after,
  .copilot-send-armed,
  .copilot-send-armed::after,
  .copilot-typing-dots span,
  .progress-bar-indicator::after,
  .hero-progress-fill::after,
  .quick-actions-fill::after,
  .assistant-task-fill::after {
    animation: none !important;
    transition: none !important;
  }
}

@media (max-width: 1280px) {
  .audit-layout {
    grid-template-columns: 14.5rem minmax(0, 1fr) clamp(19rem, 24vw, 22rem);
  }
}

@media (max-width: 1100px) {
  .audit-layout,
  .audit-layout.chat-closed {
    grid-template-columns: 13.5rem 1fr;
  }

  .audit-chat {
    display: none;
  }

  .audit-sidebar .sidebar-nav-item {
    padding-left: 1rem;
  }

  .audit-sidebar .sidebar-stepper::before {
    display: none;
  }
}

@media (max-width: 860px) {
  .audit-layout,
  .audit-layout.chat-closed {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
    height: auto;
    min-height: 100vh;
    overflow: auto;
  }

  .audit-sidebar {
    grid-row: 1;
    grid-column: 1;
  }

  .audit-header {
    grid-row: 2;
    grid-column: 1;
  }

  .audit-main {
    grid-row: 3;
    grid-column: 1;
    min-height: 0;
  }

  .audit-sidebar {
    height: auto;
  }

  .audit-brand {
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
  }

  .audit-panel {
    padding: 0.75rem;
  }

@keyframes samplingPopupIn {
  0% { opacity: 0; transform: translateY(24px) scale(0.92); }
  60% { opacity: 1; transform: translateY(-4px) scale(1.02); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

.sampling-popup {
  animation: samplingPopupIn 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.sampling-popup-backdrop {
  animation: samplingFadeIn 0.3s ease both;
}

@keyframes samplingFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes findingCardIn {
  from { opacity: 0; transform: translateY(16px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes findingCardOut {
  from { opacity: 1; transform: translateY(0) scale(1); }
  to { opacity: 0; transform: translateY(-12px) scale(0.97); }
}

.finding-card-in {
  animation: findingCardIn 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: var(--finding-delay, 0ms);
}

.finding-card-out {
  animation: findingCardOut 0.28s ease forwards;
  pointer-events: none;
}


  .floating-ai-btn {
    right: 0.8rem;
    bottom: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,sEAAsE;AACxE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,oFAAoF;EACpF,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,4CAA4C;EAC5C,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;EACpB,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV;;;qDAGmD;EACnD;;;0BAGwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb;;kEAEgE;EAChE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB;;;0BAGwB;AAC1B;;AAEA;EACE;;kEAEgE;AAClE;;AAEA;;;EAGE,6CAA6C;AAC/C;;;;AAIA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,+DAA+D;EAC/D,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,iEAAiE;EACjE,sDAAsD;AACxD;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,iFAAiF;EACjF;;+CAE6C;EAC7C,+EAA+E;AACjF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;;EAEE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACH;EAAA,sBAAqG;EAArG,4DAAqG;EAArG,kBAAqG;EAArG,4DAAqG;EAArG,oBAAqG;EAArG;AAAqG;AAArG;EAAA,sBAAqG;EAArG,0DAAqG;EAArG,qCAAqG;EAArG,oBAAqG;EAArG;AAAqG;AACnG;EAAA,sBAAiH;EAAjH,4DAAiH;EAAjH,kBAAiH;EAAjH,4DAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAAjH;EAAA,sBAAiH;EAAjH,0DAAiH;EAAjH,oCAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AACpH;EAAA,sBAAiH;EAAjH,4DAAiH;EAAjH,kBAAiH;EAAjH,4DAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAAjH;;EAAA,cAAiH;AAAA;AAAjH;EAAA,sBAAiH;EAAjH,yDAAiH;EAAjH,mCAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AACzG;EAAA,sBAAiH;EAAjH,4DAAiH;EAAjH,kBAAiH;EAAjH,4DAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAAjH;;EAAA,cAAiH;AAAA;AAAjH;EAAA,sBAAiH;EAAjH,yDAAiH;EAAjH,mCAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;;AAEzI,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEgB;EAAA,kBAAqB;EAArB;AAAqB;AACjB;EAAA;IAAA;EAAiC;AAAA;AAAjC;EAAA,yDAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AACnC;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA,yDAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAC5B;EAAA;IAAA;EAAmC;AAAA;AAAnC;EAAA,yDAAmC;EAAnC,kBAAmC;EAAnC;AAAmC;AACrC;EAAA,kBAAmB;EAAnB;AAAmB;;AAEtC,2BAA2B;AAC3B;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mEAAmE;AACrE;;AAEA,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;AAC/E;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;AACA,uDAAuD,sBAAsB,EAAE;;AAE/E,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC;;;kFAGgF;EAChF,uFAAuF;EACvF,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;;0EAEwE;EACxE,0BAA0B;EAC1B,2DAA2D;AAC7D;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,wDAAwD;AACxD;EACE,uCAAuC;EACvC;;;kFAGgF;EAChF,qFAAqF;AACvF;;AAEA;EACE;;0EAEwE;AAC1E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;;;EAGE,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE;sFACoF;EACpF,kDAAkD;EAClD,oFAAoF;AACtF;;AAEA;;EAEE,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,kDAAkD;AAClD;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB;;wHAEsH;EACtH,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;EAGE,sDAAsD;AACxD;;AAEA;;EAEE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;;EAEE,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;EAC1C;;kEAEgE;EAChE,4CAA4C;AAC9C;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;;EAEE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,qFAAqF;AACvF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,qFAAqF;EACrF,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV;;;oFAGkF;EAClF,sDAAsD;EACtD,6CAA6C;EAC7C,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yEAAyE;EACzE,6CAA6C;EAC7C,4BAA4B;AAC9B;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,iFAAiF;AACnF;;AAEA,mCAAmC;AACnC;EACE,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gGAAgG;EAChG,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,mGAAmG;EACnG,qDAAqD;EACrD,yFAAyF;EACzF,2BAA2B;AAC7B;;AAEA;EACE,8FAA8F;EAC9F,iDAAiD;EACjD,oFAAoF;AACtF;;AAEA;EACE,qFAAqF;EACrF,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kGAAkG;EAClG,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,sBAAsB,EAAE;AAClE,0CAA0C,sBAAsB,EAAE;AAClE,0CAA0C,sBAAsB,EAAE;;AAElE;EACE,6BAA6B;EAC7B,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,gDAAgD;EAChD,kEAAkE;AACpE;;AAEA;EACE,iGAAiG;EACjG,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE;;qDAEmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,SAAO;EACP,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,6FAA6F;EAC7F,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;EAC9F,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kEAAkE;EAClE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;;qDAEmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,yEAAyE;EACzE,6CAA6C;AAC/C;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE;;gEAE8D;EAC9D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD,yBAAyB;AACzB;;AAEA;EACE;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,SAAO;EACP,qCAAqC;AACvC;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,6CAA6C;EAC7C,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kGAAkG;EAClG,mDAAmD;EACnD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kEAAkE;EAClE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B;sFACoF;EACpF,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kGAAkG;AACpG;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,kDAAkD;EAClD,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,qFAAqF;AACvF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,gEAAgE;EAChE,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,uCAAuC;EACvC;;2EAEyE;EACzE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qDAAqD;EACrD,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,kFAAkF;EAClF,mDAAmD;AACrD;;AAEA;EACE,mFAAmF;EACnF,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8FAA8F;EAC9F,iDAAiD;EACjD,oFAAoF;AACtF;;AAEA;EACE,qFAAqF;EACrF,2CAA2C;AAC7C;;AAEA;EACE;;mIAEiI;EACjI,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE;;6EAE2E;EAC3E,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;;;;EAIE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,mEAAmE;AACrE;;AAEA,yBAAyB,sBAAsB,EAAE;AACjD,oBAAoB,sBAAsB,EAAE;AAC5C,mBAAmB,sBAAsB,EAAE;AAC3C,kBAAkB,qBAAqB,EAAE;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;EACxE,sDAAsD;EACtD,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,MAAM;EACN,iDAAiD;EACjD,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,SAAO;EACP,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB;;;qDAGmD;EACnD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,+CAA+C;EAC/C,yBAAyB;EACzB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,2BAA2B;AAC7B;;;AAGA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;;EAEE,6CAA6C;EAC7C,uCAAuC;EACvC,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,oBAAoB;EACpB,+CAA+C;EAC/C,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,mDAAmD;EACnD,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,4CAA4C;EAC5C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gDAAgD;AAClD;;AAEA;;;;EAIE,yHAAyH;AAC3H;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,oCAAoC;EACpC,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,2FAA2F;EAC3F,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,2EAA2E;EAC3E,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;;EAEE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,2EAA2E;EAC3E,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;;EAEE,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;gFAE8E;EAC9E,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,yFAAyF;EACzF,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;AACnE;;AAEA;EACE,yFAAyF;EACzF,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA,cAAc;AACd;EACE,OAAO,oCAAoC,EAAE;EAC7C,KAAK,uCAAuC,EAAE;AAChD;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE;IACE,iFAAiF;EACnF;EACA;IACE,iFAAiF;EACnF;AACF;;AAEA;EACE,OAAO,wCAAwC,EAAE;EACjD,KAAK,6CAA6C,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,gBAAgB,wBAAwB,EAAE,aAAa,EAAE;EACzD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,WAAW,gDAAgD,EAAE;EAC7D,MAAM,gDAAgD,EAAE;AAC1D;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,gEAAgE;EAClE;EACA;IACE,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+BE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uEAAuE;EACzE;AACF;;AAEA;EACE;;IAEE,kCAAkC;EACpC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;EACE,KAAK,UAAU,EAAE,uCAAuC,EAAE;EAC1D,MAAM,UAAU,EAAE,uCAAuC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,KAAK,UAAU,EAAE,wCAAwC,EAAE;AAC7D;;AAEA;EACE,kEAAkE;EAClE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;;EAGE;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":["/* AuditOS Styles */\n.audit-layout {\n  height: 100vh;\n  overflow: hidden;\n  font-family: \"Plus Jakarta Sans\", system-ui, -apple-system, sans-serif;\n}\n\n.audit-sidebar {\n  height: 100%;\n}\n\n.sidebar-enter {\n  animation: sidebarIn 350ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-brand {\n  position: relative;\n}\n\n.audit-panel {\n  background: transparent;\n}\n\n.audit-active-audit {\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 10px;\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.audit-health-pulse {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  display: inline-block;\n  animation: healthPulse 1.9s ease-in-out infinite;\n}\n\n.audit-health-pulse.good {\n  background: #10b981;\n  --pulse-color: rgba(16, 185, 129, 0.45);\n}\n\n.audit-health-pulse.warn {\n  background: #f59e0b;\n  --pulse-color: rgba(245, 158, 11, 0.45);\n}\n\n.audit-health-pulse.risk {\n  background: #ef4444;\n  --pulse-color: rgba(239, 68, 68, 0.45);\n}\n\n.section-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: #10b981;\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.35);\n}\n\n.audit-chip {\n  color: #cbd5e1;\n  border: 1px solid transparent;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.audit-chip:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.audit-chip.active {\n  background: rgba(16, 185, 129, 0.14);\n  border-color: rgba(16, 185, 129, 0.32);\n  color: #ecfdf5;\n  box-shadow: inset 0 0 0 1px rgba(16, 185, 129, 0.2);\n}\n\n.audit-header {\n  height: 100%;\n}\n\n.header-shell {\n  height: 100%;\n}\n\n\n.header-bar {\n  align-items: center;\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(220px, 1.15fr) minmax(280px, 1fr) minmax(320px, 1.1fr);\n  height: 100%;\n}\n\n.header-left,\n.header-center,\n.header-right {\n  min-width: 0;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.header-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.header-audit-chip {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #dbe3ee;\n  border-radius: 999px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  color: #0f172a;\n  display: inline-flex;\n  gap: 10px;\n  max-width: 100%;\n  min-height: 32px;\n  padding: 0 14px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.header-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #16a34a;\n  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);\n  flex-shrink: 0;\n}\n\n.header-brand-caption {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  padding-left: 6px;\n}\n\n.header-center {\n  display: flex;\n  justify-content: center;\n}\n\n.header-search-wrap {\n  position: relative;\n  width: min(100%, 420px);\n}\n\n.header-search-icon {\n  color: #64748b;\n  left: 14px;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.header-search-input {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 999px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  color: #0f172a !important;\n  height: 40px;\n  padding-left: 42px !important;\n}\n\n.header-search-input::placeholder {\n  color: #94a3b8;\n}\n\n.header-right {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.header-date-pill {\n  white-space: nowrap;\n}\n\n.header-avatar {\n  flex-shrink: 0;\n}\n\n.audit-main {\n  grid-row: 2;\n  grid-column: 2;\n  overflow: hidden;\n  position: relative;\n  padding: 0;\n  background:\n    radial-gradient(circle at top right, rgba(5, 150, 105, 0.08), transparent 22%),\n    radial-gradient(circle at top left, rgba(16, 185, 129, 0.06), transparent 20%),\n    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  box-shadow:\n    inset 1px 0 0 #dbe4f0,\n    inset -1px 0 0 #dbe4f0,\n    inset 0 -1px 0 #dbe4f0;\n}\n\n.audit-main::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 196px;\n  background:\n    radial-gradient(circle at top right, rgba(226, 232, 240, 0.22), transparent 30%),\n    linear-gradient(120deg, #f8fafc 0%, #f1f5f9 55%, #e2e8f0 100%);\n  z-index: 0;\n}\n\n.audit-main > * {\n  position: relative;\n  z-index: 1;\n}\n\n.audit-main > [data-testid=\"integrations-page\"],\n.audit-main > [data-testid=\"model-config-page\"],\n.audit-main > [data-testid=\"audit-logs-page\"],\n.audit-main > [data-testid=\"user-management-page\"] {\n  margin-top: 0.75rem;\n}\n\n.dark .audit-main {\n  background: #121722;\n  box-shadow:\n    inset 1px 0 0 #292f3b,\n    inset -1px 0 0 #292f3b,\n    inset 0 -1px 0 #292f3b;\n}\n\n.dark .audit-main::before {\n  background:\n    radial-gradient(circle at top right, rgba(148, 163, 184, 0.18), transparent 28%),\n    linear-gradient(120deg, #0b1220 0%, #111827 42%, #1f2937 100%);\n}\n\n.dark .audit-main .bg-card,\n.dark .audit-main [class*=\"bg-card/\"],\n.dark .audit-main .bg-background {\n  background-color: hsl(var(--card)) !important;\n}\n\n\n\n/* Phase progress */\n.phase-step {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.phase-step-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  z-index: 1;\n  transition: all 200ms ease;\n  animation: phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--phase-delay, 0ms);\n}\n\n.phase-step-line {\n  position: absolute;\n  top: 14px;\n  left: 50%;\n  width: 100%;\n  height: 2px;\n  z-index: 0;\n  background: hsl(var(--border));\n  overflow: hidden;\n}\n\n.phase-step-line::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform-origin: left center;\n  transform: scaleX(0);\n  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--chart-2)));\n}\n\n.phase-step-line.is-active::after {\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);\n}\n\n.phase-step-button:hover .phase-step-dot {\n  transform: translateY(-2px) scale(1.04);\n  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.08);\n}\n\n.phase-step-dot.is-current {\n  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);\n  animation:\n    phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both,\n    currentPhasePulse 2.6s ease-in-out infinite;\n  animation-delay: var(--phase-delay, 0ms), calc(var(--phase-delay, 0ms) + 420ms);\n}\n\n.phase-step-dot.is-complete {\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);\n}\n\n.phase-progress-shell .phase-step span {\n  animation: rowIn 320ms ease both;\n  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);\n}\n\n/* Labels */\n.label-xs {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* Data table density */\n.table-dense th,\n.table-dense td {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8125rem;\n}\n\n.table-dense th {\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Severity badges */\n.severity-high { @apply bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-400 dark:border-red-900; }\n.severity-medium { @apply bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/30 dark:text-amber-400 dark:border-amber-900; }\n.severity-low { @apply bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-950/30 dark:text-slate-400 dark:border-slate-900; }\n.severity-observation { @apply bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-950/30 dark:text-slate-400 dark:border-slate-900; }\n\n/* Status indicators */\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.status-ready { @apply bg-emerald-500; }\n.status-ingesting { @apply bg-amber-500 animate-pulse; }\n.status-parsing { @apply bg-red-500 animate-pulse; }\n.status-extracting { @apply bg-emerald-500 animate-pulse; }\n.status-uploaded { @apply bg-slate-400; }\n\n/* Chat message animation */\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.chat-message-enter {\n  animation: fadeInUp 200ms ease-out;\n}\n\n/* Ambient Motion Layer */\n.ambient-canvas {\n  position: relative;\n  isolation: isolate;\n}\n\n.audit-main .ambient-orb,\n.audit-main .ambient-particles {\n  display: block;\n}\n\n/* Keep dashboard content white over the branded surface */\n.audit-main .bg-card,\n.audit-main [class*=\"bg-card/\"],\n.audit-main .bg-background {\n  background-color: #ffffff !important;\n}\n\n.audit-main .border {\n  border-color: rgba(129, 140, 248, 0.28);\n}\n\n/* Make top phase header text readable over the hero strip */\n.audit-main [data-testid^=\"phase-\"] > div:first-child h2 {\n  color: #0f172a !important;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.55);\n}\n\n.audit-main .section-content {\n  padding: 1.5rem 2rem 2rem;\n} \n\n.audit-main [data-testid^=\"phase-\"] > div:first-child p {\n  color: #475569 !important;\n}\n\n.audit-main [data-testid^=\"phase-\"] {\n  animation: phasePageIn 560ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-main [data-testid^=\"phase-\"] > * {\n  animation: phaseSectionIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(1) { animation-delay: 40ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(2) { animation-delay: 110ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(3) { animation-delay: 180ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(4) { animation-delay: 250ms; }\n.dark .audit-main [data-testid^=\"phase-\"] > div:first-child h2 {\n  color: #ffffff !important;\n  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.4);\n}\n\n.dark .audit-main [data-testid^=\"phase-\"] > div:first-child p {\n  color: #d1fae5 !important;\n}\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(5) { animation-delay: 320ms; }\n\n/* Phase 7 command-center treatment */\n.phase7-hero {\n  position: relative;\n  isolation: isolate;\n  border-color: rgba(148, 163, 184, 0.24);\n  background:\n    linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.92) 48%, rgba(241, 245, 249, 0.96) 100%),\n    radial-gradient(circle at 12% 0%, rgba(16, 185, 129, 0.12), transparent 30%),\n    radial-gradient(circle at 88% 18%, rgba(148, 163, 184, 0.12), transparent 36%);\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.85);\n  animation: heroGradientDrift 14s ease-in-out infinite alternate;\n}\n\n.phase7-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-image:\n    linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);\n  background-size: 44px 44px;\n  mask-image: linear-gradient(180deg, black, transparent 78%);\n}\n\n.phase7-hero p,\n.phase7-hero h2 {\n  color: inherit !important;\n}\n\n.phase7-hero .text-slate-300 {\n  color: #475569 !important;\n}\n\n.phase7-hero .text-slate-400 {\n  color: #64748b !important;\n}\n\n.phase7-hero .text-cyan-200\\/90 {\n  color: rgba(8, 145, 178, 0.9) !important;\n}\n\n/* Dark mode overrides for Phase 7 hero card and stats */\n.dark .phase7-hero {\n  border-color: rgba(148, 163, 184, 0.14);\n  background:\n    linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(23, 29, 46, 0.96) 48%, rgba(30, 41, 59, 0.98) 100%),\n    radial-gradient(circle at 12% 0%, rgba(16, 185, 129, 0.16), transparent 30%),\n    radial-gradient(circle at 88% 18%, rgba(148, 163, 184, 0.12), transparent 36%);\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.36), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.dark .phase7-hero::after {\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);\n}\n\n.dark .phase7-hero .text-slate-300 {\n  color: #cbd5e1 !important;\n}\n\n.dark .phase7-hero .text-slate-400 {\n  color: #94a3b8 !important;\n}\n\n.dark .phase7-hero .text-cyan-200\\/90 {\n  color: rgba(165, 243, 252, 0.95) !important;\n}\n\n.phase7-stat {\n  backdrop-filter: blur(10px);\n  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;\n}\n\n.phase7-stat:hover {\n  transform: translateY(-2px);\n  border-color: rgba(16, 185, 129, 0.26);\n  background: rgba(255, 255, 255, 0.86);\n}\n\n.dark .phase7-stat:hover {\n  border-color: rgba(16, 185, 129, 0.4);\n  background: rgba(30, 41, 59, 0.86);\n}\n\n.phase7-console-card,\n.phase7-control-row,\n.phase7-progress-card {\n  animation: phaseSectionIn 480ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.phase7-console-card {\n  overflow: hidden;\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.08);\n}\n\n.dark .phase7-console-card {\n  background:\n    linear-gradient(180deg, rgba(23, 29, 46, 0.94), rgba(15, 23, 42, 0.96)) !important;\n  border-color: rgba(129, 140, 248, 0.22) !important;\n  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dark .phase7-control-panel,\n.dark .phase7-progress-card {\n  background: rgba(2, 6, 23, 0.28) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n}\n\n.dark .phase7-control-row {\n  background: rgba(15, 23, 42, 0.72) !important;\n  border-color: rgba(148, 163, 184, 0.16) !important;\n}\n\n.dark .phase7-control-row:hover {\n  border-color: rgba(45, 212, 191, 0.34) !important;\n}\n\n/* Phase 10 readability on the branded dashboard */\n.phase10-readable,\n.phase10-readable * {\n  color: #0f172a;\n}\n\n.phase10-readable .text-muted-foreground {\n  color: #111827 !important;\n}\n\n.phase10-readable .text-\\[10px\\],\n.phase10-readable .text-\\[9px\\],\n.phase10-readable .text-\\[8px\\] {\n  color: #1f2937 !important;\n}\n\n.phase10-no-gap {\n  margin: -24px -24px 0;\n  padding: 0 8px 24px;\n}\n\n.phase10-report-header {\n  margin: 0 -8px;\n  padding: 18px 20px;\n  border: 1px solid rgba(5, 150, 105, 0.16);\n  border-radius: 18px;\n  background:\n    radial-gradient(circle at top right, rgba(167, 243, 208, 0.22), transparent 30%),\n    linear-gradient(135deg, rgba(255, 255, 255, 0.97) 0%, rgba(248, 250, 252, 0.96) 48%, rgba(236, 253, 245, 0.95) 100%);\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);\n}\n\n.phase10-report-header-attached {\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.phase10-report-header .bg-white\\/80,\n.phase10-report-header [class*=\"bg-card\"],\n.phase10-report-header [class*=\"bg-background\"] {\n  background-color: rgba(255, 255, 255, 0.76) !important;\n}\n\n.phase10-report-header button,\n.phase10-report-header [role=\"combobox\"] {\n  border-color: rgba(148, 163, 184, 0.22) !important;\n  color: #0f172a;\n}\n\n.phase10-report-header button:hover,\n.phase10-report-header [role=\"combobox\"]:hover {\n  background-color: rgba(241, 245, 249, 0.9) !important;\n}\n\n.dark .phase10-report-header {\n  border: 1px solid rgba(52, 211, 153, 0.18);\n  background:\n    radial-gradient(circle at top right, rgba(52, 211, 153, 0.16), transparent 30%),\n    linear-gradient(120deg, #0f172a 0%, #064e3b 42%, #111827 100%);\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.22);\n}\n\n.dark .phase10-report-header .bg-white\\/80,\n.dark .phase10-report-header [class*=\"bg-card\"],\n.dark .phase10-report-header [class*=\"bg-background\"] {\n  background-color: rgba(15, 23, 42, 0.72) !important;\n}\n\n.dark .phase10-report-header button,\n.dark .phase10-report-header [role=\"combobox\"] {\n  border-color: rgba(255, 255, 255, 0.18) !important;\n  color: #ffffff;\n}\n\n.dark .phase10-report-header button:hover,\n.dark .phase10-report-header [role=\"combobox\"]:hover {\n  background-color: rgba(255, 255, 255, 0.12) !important;\n}\n\n.phase10-command-brief {\n  margin-top: -1.5rem !important;\n  border-top-right-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.ambient-orb {\n  position: fixed;\n  pointer-events: none;\n  z-index: 0;\n  filter: blur(34px);\n  opacity: 0.2;\n  border-radius: 9999px;\n  animation: orbFloat 10s ease-in-out infinite alternate;\n}\n\n.orb-one {\n  width: 280px;\n  height: 280px;\n  right: 14%;\n  top: 18%;\n  background: radial-gradient(circle, rgba(16,185,129,0.28) 0%, rgba(16,185,129,0) 70%);\n}\n\n.orb-two {\n  width: 220px;\n  height: 220px;\n  right: 34%;\n  bottom: 8%;\n  background: radial-gradient(circle, rgba(52,211,153,0.22) 0%, rgba(52,211,153,0) 70%);\n  animation-delay: 1.2s;\n}\n\n.ambient-particles {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  background-image:\n    radial-gradient(circle at 10% 18%, rgba(110,231,183,0.18) 1px, transparent 1.6px),\n    radial-gradient(circle at 70% 35%, rgba(16,185,129,0.15) 1px, transparent 1.6px),\n    radial-gradient(circle at 35% 72%, rgba(45,212,191,0.15) 1px, transparent 1.6px);\n  background-size: 320px 320px, 260px 260px, 380px 380px;\n  animation: particlesDrift 16s linear infinite;\n  display: none;\n}\n\n/* Sidebar and Nav Animations */\n.sidebar-logo-anim {\n  transform-origin: center;\n  transition: transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.sidebar-logo-anim:hover {\n  transform: rotate(-7deg) scale(1.06);\n}\n\n.sidebar-nav-item {\n  position: relative;\n  overflow: hidden;\n  animation: navItemIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--stagger, 0ms);\n  transition: transform 170ms ease, box-shadow 170ms ease;\n}\n\n.sidebar-nav-item:hover {\n  transform: translateX(3px);\n}\n\n.sidebar-nav-item .nav-icon {\n  transition: transform 180ms ease, color 180ms ease;\n}\n\n.sidebar-nav-item:hover .nav-icon {\n  transform: scale(1.08);\n  color: #10b981;\n}\n\n.sidebar-nav-item.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 18%;\n  height: 64%;\n  width: 3px;\n  border-radius: 999px;\n  background: #10b981;\n  box-shadow: 0 0 12px rgba(16, 185, 129, 0.5);\n}\n\n.sidebar-stepper {\n  position: relative;\n}\n\n.sidebar-stepper::before {\n  display: none;\n}\n\n.sidebar-stepper .sidebar-nav-item {\n  padding-left: 0.95rem;\n}\n\n.sidebar-journey-progress {\n  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);\n  box-shadow: 0 0 14px rgba(139, 92, 246, 0.35);\n  transition: width 260ms ease;\n}\n\n\n\n.sidebar-stepper .sidebar-nav-item.is-complete .nav-icon {\n  color: #c4b5fd;\n}\n\n.sidebar-profile-avatar {\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.16), 0 8px 20px rgba(30, 41, 59, 0.18);\n}\n\n.profile-summary-avatar {\n  box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.16), 0 10px 24px rgba(30, 41, 59, 0.2);\n}\n\n/* Quick Action Micro-Interaction */\n.quick-action {\n  transition: transform 160ms ease, color 160ms ease;\n}\n\n.quick-action:hover {\n  transform: translateX(4px);\n}\n\n/* Metric Card Entrance + Hover Lift */\n.metric-card-anim {\n  position: relative;\n  overflow: hidden;\n  animation: metricIn 580ms cubic-bezier(0.2, 0.9, 0.15, 1.1) both;\n  animation-delay: var(--delay, 0ms);\n  transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.metric-card-anim::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: linear-gradient(90deg, rgba(16,185,129,0), rgba(16,185,129,0.8), rgba(16,185,129,0));\n  opacity: 0;\n  transform: translateY(2px);\n  transition: opacity 180ms ease, transform 180ms ease;\n}\n\n.metric-card-anim:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n}\n\n.metric-card-anim:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.audit-card {\n  position: relative;\n  overflow: hidden;\n}\n\n.audit-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.08) 18%, transparent 36%);\n  opacity: 0;\n  transform: translateX(-18%);\n  transition: opacity 220ms ease, transform 420ms ease;\n  pointer-events: none;\n}\n\n.audit-card:hover::before {\n  opacity: 1;\n  transform: translateX(18%);\n}\n\n.dark .audit-card:hover {\n  box-shadow: 0 24px 50px rgba(2, 6, 23, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.executive-glass {\n  background: linear-gradient(140deg, rgba(255, 255, 255, 0.9), rgba(236, 253, 245, 0.78)) !important;\n  border: 1px solid rgba(16, 185, 129, 0.18) !important;\n  box-shadow: 0 16px 34px rgba(16, 185, 129, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.55);\n  backdrop-filter: blur(10px);\n}\n\n.dark .executive-glass {\n  background: linear-gradient(140deg, rgba(26, 26, 27, 0.72), rgba(17, 24, 39, 0.55)) !important;\n  border-color: rgba(45, 212, 191, 0.35) !important;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.executive-hero {\n  background: linear-gradient(120deg, #064e3b 0%, #059669 52%, #34d399 100%) !important;\n  box-shadow: 0 16px 30px rgba(5, 150, 105, 0.18);\n}\n\n.hero-progress-wrap {\n  min-width: 250px;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(254, 202, 202, 0.5);\n  border-radius: 16px;\n  padding: 12px;\n  backdrop-filter: blur(6px);\n}\n\n.hero-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: 700;\n}\n\n.hero-progress-track {\n  height: 8px;\n  border-radius: 999px;\n  margin-top: 8px;\n  background: rgba(254, 202, 202, 0.44);\n  overflow: hidden;\n}\n\n.hero-progress-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #fee2e2, #ffffff);\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-progress-fill::after,\n.quick-actions-fill::after,\n.assistant-task-fill::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 48%, transparent 100%);\n  transform: translateX(-120%);\n  animation: scanSweep 1.9s ease-in-out infinite;\n}\n\n/* Table Row Reveal + Progress */\n.table-row-anim {\n  animation: rowIn 380ms ease both;\n  animation-delay: var(--row-delay, 0ms);\n}\n\n.audit-main table tbody tr {\n  animation: rowIn 420ms ease both;\n}\n\n.audit-main table tbody tr:nth-child(1) { animation-delay: 50ms; }\n.audit-main table tbody tr:nth-child(2) { animation-delay: 90ms; }\n.audit-main table tbody tr:nth-child(3) { animation-delay: 130ms; }\n.audit-main table tbody tr:nth-child(4) { animation-delay: 170ms; }\n.audit-main table tbody tr:nth-child(5) { animation-delay: 210ms; }\n\n.progress-anim {\n  transform-origin: left center;\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  animation-delay: 120ms;\n}\n\n.progress-bar-indicator {\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar-indicator::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.35) 45%, transparent 100%);\n  transform: translateX(-125%);\n  animation: scanSweep 2.1s ease-in-out infinite;\n}\n\n/* Notification Pulse */\n.notification-pulse {\n  animation: bellPulse 1.8s ease-in-out infinite;\n}\n\n/* Floating AI Button */\n.floating-ai-btn {\n  position: fixed;\n  right: 1.2rem;\n  bottom: 1.2rem;\n  z-index: 40;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #047857, #10b981);\n  color: white;\n  box-shadow: 0 16px 32px rgba(16, 185, 129, 0.24);\n  animation: floatBtnIn 540ms cubic-bezier(0.2, 0.95, 0.2, 1.2) both;\n}\n\n.audit-chat-panel {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(254, 242, 242, 0.98) 100%);\n  color: hsl(var(--foreground));\n}\n\n.dark .copilot-shell {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  color: hsl(var(--foreground));\n}\n\n.audit-chat-panel .chat-header {\n  background: rgba(255, 255, 255, 0.72);\n  border-color: hsl(var(--border));\n}\n\n.audit-chat-panel .chat-composer {\n  background: rgba(255, 255, 255, 0.78);\n  border-color: hsl(var(--border));\n}\n\n/* Light mode - copilot shell defaults */\n.copilot-shell {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  color: hsl(var(--foreground));\n}\n\n.copilot-header {\n  padding: 16px 14px;\n  background: rgba(255, 255, 255, 0.86);\n  border-color: hsl(var(--border));\n}\n\n.copilot-title {\n  color: #4f46e5;\n  font-size: clamp(0.95rem, 1.4vw, 1.125rem);\n  line-height: 1.1;\n}\n\n.copilot-context {\n  color: hsl(var(--muted-foreground));\n  letter-spacing: 0.14em;\n  line-height: 1.25;\n}\n\n.copilot-avatar {\n  border: 2px solid rgba(79, 70, 229, 0.5);\n}\n\n.copilot-icon-btn {\n  color: #4f46e5;\n  background: rgba(79, 70, 229, 0.08);\n  border: 1px solid rgba(79, 70, 229, 0.2);\n}\n\n.copilot-icon-btn:hover {\n  background: rgba(79, 70, 229, 0.12);\n  color: #4338ca;\n}\n\n.copilot-scroll {\n  background: linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px),\n    linear-gradient(0deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px),\n    linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);\n}\n\n.copilot-day-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: hsl(var(--muted-foreground));\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.copilot-day-divider::before,\n.copilot-day-divider::after {\n  content: \"\";\n  height: 1px;\n  flex: 1;\n  background: hsl(var(--border));\n  opacity: 0.6;\n}\n\n.copilot-day-divider {\n  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.copilot-context-card {\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(6, 182, 212, 0.04) 100%);\n  border-color: rgba(79, 70, 229, 0.2);\n  border-radius: 16px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.copilot-welcome {\n  background: linear-gradient(135deg, rgba(20, 184, 166, 0.06) 0%, rgba(6, 182, 212, 0.04) 100%);\n  border-color: rgba(20, 184, 166, 0.25);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.copilot-welcome-actions > button {\n  max-width: 100%;\n  white-space: nowrap;\n}\n\n.copilot-welcome .bg-primary {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n}\n\n.copilot-welcome .bg-primary:hover {\n  background: linear-gradient(135deg, #818cf8, #a78bfa);\n}\n\n.copilot-bot-mark {\n  background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%);\n  color: #ffffff;\n  position: relative;\n  overflow: hidden;\n}\n\n.copilot-user-mark {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: #ffffff;\n  border: none;\n}\n\n.copilot-message-row {\n  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--message-delay, 0ms);\n}\n\n.message-user-row {\n  transform-origin: right center;\n}\n\n.message-assistant-row {\n  transform-origin: left center;\n}\n\n.copilot-message {\n  border-radius: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: hidden;\n}\n\n.copilot-user-message {\n  border-top-right-radius: 6px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.26);\n}\n\n.copilot-user-message::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);\n  transform: translateX(-120%);\n  animation: messageShimmer 4.2s ease-in-out infinite;\n}\n\n.copilot-assistant-message {\n  border-top-left-radius: 6px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border-color: rgba(79, 70, 229, 0.15);\n}\n\n.copilot-message-text {\n  color: hsl(var(--foreground));\n}\n\n.copilot-message-text strong {\n  color: hsl(var(--foreground));\n  font-weight: 600;\n}\n\n.audit-chat-panel .quick-action {\n  background: hsl(var(--card));\n  border-color: hsl(var(--border));\n  color: hsl(var(--foreground));\n}\n\n.audit-chat-panel .quick-action:hover {\n  border-color: hsl(var(--primary));\n  background: hsl(var(--accent));\n}\n\n.copilot-evidence-card {\n  background: hsl(var(--accent));\n  border-color: hsl(var(--border));\n}\n\n.copilot-composer {\n  background: hsl(var(--card));\n  border-color: hsl(var(--border));\n}\n\n.copilot-chip {\n  background: hsl(var(--secondary));\n  color: hsl(var(--secondary-foreground));\n  border-color: hsl(var(--border));\n}\n\n.copilot-chip:hover {\n  background: hsl(var(--secondary))\\/90;\n}\n\n.copilot-input-shell {\n  background: hsl(var(--input));\n  border-color: hsl(var(--border));\n  color: hsl(var(--foreground));\n}\n\n.copilot-input-icon {\n  color: hsl(var(--muted-foreground));\n}\n\n.copilot-input-icon:hover {\n  color: hsl(var(--foreground));\n}\n\n.copilot-send {\n  background: hsl(var(--primary));\n  color: hsl(var(--primary-foreground));\n}\n\n.copilot-send:hover {\n  background: hsl(var(--primary))\\/90;\n}\n\n.copilot-send-armed {\n  box-shadow: 0 0 18px rgba(79, 70, 229, 0.42);\n}\n\n.copilot-send-armed::after {\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4) 40%, transparent);\n}\n\n.copilot-thinking-row {\n  background: transparent;\n}\n\n.copilot-thinking-mark {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: #ffffff;\n}\n\n.copilot-thinking-bubble {\n  background: hsl(var(--card));\n  border-color: hsl(var(--border));\n  color: hsl(var(--foreground));\n}\n\n.copilot-typing-dots span {\n  background: hsl(var(--muted-foreground));\n}\n\n.dark .audit-sidebar {\n  background:\n    radial-gradient(circle at top left, rgba(16, 185, 129, 0.12), transparent 28%),\n    linear-gradient(180deg, #0f172a 0%, #0b1329 100%);\n}\n\n.dark .audit-sidebar .text-muted-foreground {\n  color: #94a3b8 !important;\n}\n\n.dark .audit-sidebar .sidebar-nav-item {\n  color: #cbd5e1;\n}\n\n.dark .audit-sidebar .sidebar-nav-item:hover {\n  background: rgba(16, 185, 129, 0.12);\n  color: #f8fafc;\n}\n\n.dark .audit-sidebar .sidebar-nav-item.active {\n  color: #ffffff;\n  background: rgba(16, 185, 129, 0.18);\n}\n\n.dark .sidebar-journey-progress {\n  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 52%, #a855f7 100%);\n  box-shadow: 0 0 18px rgba(139, 92, 246, 0.38);\n}\n\n.dark .audit-panel {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n}\n\n.dark .audit-active-audit {\n  background: rgba(15, 23, 42, 0.72);\n  border-color: rgba(129, 140, 248, 0.28);\n  color: #e2e8f0 !important;\n}\n\n.dark .audit-active-audit .text-foreground {\n  color: #ffffff !important;\n}\n\n.dark .audit-active-audit .text-muted-foreground {\n  color: #cbd5e1 !important;\n}\n\n.dark .audit-chat {\n  border-left-color: rgba(148, 163, 184, 0.18);\n  background: linear-gradient(180deg, #111827 0%, #0f172a 100%);\n}\n\n.dark .audit-chat-panel {\n  background: linear-gradient(180deg, #1c1f29 0%, #12151c 100%);\n  color: #f8fafc;\n}\n\n.dark .audit-chat-panel .chat-header {\n  background: rgba(15, 23, 42, 0.86);\n  border-color: rgba(148, 163, 184, 0.2);\n}\n\n.dark .audit-chat-panel .chat-composer {\n  background: rgba(15, 23, 42, 0.92);\n  border-color: rgba(148, 163, 184, 0.2);\n}\n\n.dark .copilot-shell {\n  background:\n    radial-gradient(circle at top right, rgba(129, 140, 248, 0.12), transparent 28%),\n    linear-gradient(180deg, #111827 0%, #0b1220 100%) !important;\n  color: #e5e7eb;\n}\n\n.dark .copilot-header {\n  padding: 16px 14px;\n  background: rgba(15, 23, 42, 0.86) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.24);\n}\n\n.dark .copilot-title {\n  color: #a5b4fc;\n  font-size: clamp(0.95rem, 1.4vw, 1.125rem);\n  line-height: 1.1;\n  text-shadow: 0 0 18px rgba(129, 140, 248, 0.26);\n}\n\n.dark .copilot-context {\n  color: #94a3b8;\n  letter-spacing: 0.14em;\n  line-height: 1.25;\n}\n\n.dark .copilot-avatar {\n  border: 2px solid rgba(199, 210, 254, 0.86);\n  box-shadow: 0 0 24px rgba(129, 140, 248, 0.24);\n}\n\n.dark .copilot-icon-btn {\n  color: #a5b4fc !important;\n  background: rgba(15, 23, 42, 0.44) !important;\n  border: 1px solid rgba(129, 140, 248, 0.14);\n}\n\n.dark .copilot-icon-btn:hover {\n  background: rgba(129, 140, 248, 0.16) !important;\ncolor: #ddd6fe !important;\n}\n\n.dark .copilot-scroll {\n  background:\n    linear-gradient(90deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px),\n    linear-gradient(180deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px);\n  background-size: 44px 44px;\n}\n\n.dark .copilot-day-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.dark .copilot-day-divider::before,\n.dark .copilot-day-divider::after {\n  content: \"\";\n  height: 1px;\n  flex: 1;\n  background: rgba(148, 163, 184, 0.14);\n}\n\n.dark .copilot-day-divider {\n  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.dark .copilot-context-card {\n  background: rgba(15, 23, 42, 0.54) !important;\n  border-color: rgba(99, 102, 241, 0.24) !important;\n  border-radius: 16px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.dark .copilot-welcome {\n  background: linear-gradient(135deg, rgba(20, 184, 166, 0.18), rgba(99, 102, 241, 0.12)) !important;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.dark .copilot-welcome-actions > button {\n  max-width: 100%;\n  white-space: nowrap;\n}\n\n.dark .copilot-welcome .bg-primary {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;\n}\n\n.dark .copilot-welcome .bg-primary:hover {\n  background: linear-gradient(135deg, #818cf8, #a78bfa) !important;\n}\n\n.dark .copilot-bot-mark {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #eef2ff;\n  box-shadow: 0 12px 26px rgba(79, 70, 229, 0.28);\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .copilot-user-mark {\n  background: rgba(20, 184, 166, 0.14);\n  color: #99f6e4;\n  border: 1px solid rgba(45, 212, 191, 0.18);\n}\n\n.dark .copilot-message-row {\n  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--message-delay, 0ms);\n}\n\n.dark .message-user-row {\n  transform-origin: right center;\n}\n\n.dark .message-assistant-row {\n  transform-origin: left center;\n}\n\n.dark .copilot-message {\n  border-radius: 20px;\n  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .copilot-user-message {\n  border-top-right-radius: 6px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);\n  box-shadow: 0 16px 34px rgba(79, 70, 229, 0.26);\n}\n\n.dark .copilot-user-message::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);\n  transform: translateX(-120%);\n  animation: messageShimmer 4.2s ease-in-out infinite;\n}\n\n.dark .copilot-assistant-message {\n  border-top-left-radius: 6px;\n  background:\n    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96)) !important;\n  border-color: rgba(129, 140, 248, 0.18) !important;\n}\n\n.dark .copilot-assistant-message::before {\n  content: \"\";\n  position: absolute;\n  inset: auto -20% 0 -20%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, rgba(45, 212, 191, 0.42) 50%, transparent 100%);\n}\n\n.dark .copilot-message-text {\n  color: #e5e7eb;\n}\n\n.dark .copilot-message-text strong {\n  color: #2dd4bf;\n  font-weight: 800;\n}\n\n.dark .audit-chat-panel .quick-action {\n  display: flex;\n  min-height: 2.25rem;\n  align-items: center;\n  color: #e5e7eb !important;\n  background: rgba(15, 23, 42, 0.72) !important;\n  border-color: rgba(129, 140, 248, 0.18) !important;\n  line-height: 1.35;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.dark .audit-chat-panel .quick-action:hover {\n  background: rgba(20, 184, 166, 0.13) !important;\n  border-color: rgba(45, 212, 191, 0.36) !important;\n}\n\n.dark .copilot-evidence-card {\n  background: rgba(2, 6, 23, 0.22);\n  border-radius: 12px;\n  padding: 8px;\n}\n\n.dark .copilot-composer {\n  background: rgba(15, 23, 42, 0.92) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n}\n\n.dark .copilot-chip {\n  border-color: rgba(129, 140, 248, 0.26) !important;\n  background: rgba(15, 23, 42, 0.64) !important;\n  color: #c7d2fe !important;\n}\n\n.dark .copilot-chip:hover {\n  background: rgba(99, 102, 241, 0.18) !important;\n}\n\n.dark .copilot-input-shell {\n  min-height: 56px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 22px;\n  background: rgba(15, 23, 42, 0.9);\n  padding: 6px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 18px 36px rgba(2, 6, 23, 0.22);\n}\n\n.dark .copilot-input-icon {\n  color: #94a3b8 !important;\n}\n\n.dark .copilot-input-icon:hover {\n  color: #c7d2fe !important;\n  background: rgba(129, 140, 248, 0.12) !important;\n}\n\n.dark .copilot-send {\n  border-radius: 18px !important;\n  background: linear-gradient(135deg, #c4b5fd, #6366f1) !important;\n  color: #111827 !important;\n  box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34);\n  position: relative;\n  overflow: hidden;\n}\n\n.dark .copilot-send:hover {\n  background: linear-gradient(135deg, #ddd6fe, #818cf8) !important;\n  transform: translateY(-1px);\n}\n\n.dark .copilot-send-armed {\n  animation: sendPulse 1.6s ease-in-out infinite;\n}\n\n.dark .copilot-send-armed::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.36) 40%, transparent 70%);\n  transform: translateX(-125%);\n  animation: messageShimmer 2.8s ease-in-out infinite;\n}\n\n.dark .copilot-thinking-row {\n  animation: phaseSectionIn 320ms ease both;\n}\n\n.dark .copilot-thinking-mark {\n  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.08), 0 0 24px rgba(45, 212, 191, 0.22);\n}\n\n.dark .copilot-thinking-bubble {\n  border-color: rgba(129, 140, 248, 0.24);\n  background:\n    radial-gradient(circle at top right, rgba(45, 212, 191, 0.12), transparent 35%),\n    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96));\n  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.2);\n}\n\n.dark .copilot-typing-dots {\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.dark .copilot-typing-dots span {\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #2dd4bf, #a5b4fc);\n  animation: typingBounce 0.95s ease-in-out infinite;\n}\n\n.dark .copilot-typing-dots span:nth-child(2) {\n  animation-delay: 0.12s;\n}\n\n.dark .copilot-typing-dots span:nth-child(3) {\n  animation-delay: 0.24s;\n}\n\n.dark .assistant-overlay {\n  border-color: rgba(52, 211, 153, 0.24);\n  background: linear-gradient(135deg, rgba(6, 95, 70, 0.34), rgba(27, 31, 40, 0.95));\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dark .assistant-overlay-card {\n  background: linear-gradient(145deg, rgba(28, 30, 39, 0.96), rgba(20, 22, 30, 0.98));\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);\n}\n\n.dark .assistant-task-track {\n  background: rgba(16, 185, 129, 0.18);\n}\n\n.dark .quick-actions-item {\n  border-color: rgba(52, 211, 153, 0.2);\n  background: rgba(26, 28, 36, 0.88);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n}\n\n.dark .quick-actions-track {\n  background: rgba(71, 85, 105, 0.45);\n}\n\n.dark .executive-glass {\n  background: linear-gradient(140deg, rgba(33, 36, 46, 0.94), rgba(20, 23, 31, 0.88)) !important;\n  border-color: rgba(52, 211, 153, 0.18) !important;\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.dark .executive-hero {\n  background: linear-gradient(120deg, #065f46 0%, #059669 40%, #0b1220 100%) !important;\n  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);\n}\n\n.phase10-command-brief {\n  background:\n    radial-gradient(circle at top right, rgba(167, 243, 208, 0.28), transparent 32%),\n    linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(236, 253, 245, 0.96) 55%, rgba(209, 250, 229, 0.92) 100%) !important;\n  border: 1px solid rgba(5, 150, 105, 0.16) !important;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);\n}\n\n.dark .phase10-command-brief {\n  background:\n    radial-gradient(circle at top right, rgba(52, 211, 153, 0.16), transparent 30%),\n    linear-gradient(120deg, #0f172a 0%, #064e3b 45%, #0b1220 100%) !important;\n  border: 1px solid rgba(52, 211, 153, 0.22) !important;\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.24);\n}\n\n.dark .hero-progress-wrap {\n  background: rgba(17, 24, 39, 0.34);\n  border-color: rgba(255, 234, 214, 0.12);\n}\n\n.hero-progress-wrap {\n  background: rgba(255, 255, 255, 0.68);\n  border-color: rgba(5, 150, 105, 0.16);\n}\n\n[data-testid=\"phase-10\"] > div:first-child h2 {\n  color: #ffffff !important;\n  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.35);\n}\n\n[data-testid=\"phase-10\"] > div:first-child p {\n  color: #d1fae5 !important;\n}\n\n.dark .hero-progress-track {\n  background: rgba(255, 245, 235, 0.1);\n}\n\n.dark .hero-progress-fill {\n  background: linear-gradient(90deg, #fecaca, #fee2e2);\n}\n\n.dark .phase10-readable,\n.dark .phase10-readable * {\n  color: hsl(var(--foreground));\n}\n\n.dark .phase10-readable .phase10-print-preview,\n.dark .phase10-readable .phase10-print-preview * {\n  color: #111827 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview .text-muted-foreground,\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #9ca3af\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#9ca3af\"] {\n  color: #4b5563 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #374151\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#374151\"] {\n  color: #374151 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview h3,\n.dark .phase10-readable .phase10-print-preview table,\n.dark .phase10-readable .phase10-print-preview table td,\n.dark .phase10-readable .phase10-print-preview table th,\n.dark .phase10-readable .phase10-print-preview p,\n.dark .phase10-readable .phase10-print-preview span,\n.dark .phase10-readable .phase10-print-preview li {\n  color: #111827 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview table th,\n.dark .phase10-readable .phase10-print-preview p[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview span[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview td[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#6b7280\"] {\n  color: #4b5563 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview .phase10-finding-card,\n.dark .phase10-readable .phase10-print-preview .phase10-finding-card * {\n  color: #f8fafc !important;\n}\n\n.dark .phase10-readable .text-muted-foreground {\n  color: #cbd5e1 !important;\n}\n\n.dark .phase10-readable .recharts-cartesian-axis-tick-value,\n.dark .phase10-readable .recharts-polar-angle-axis text,\n.dark .phase10-readable .recharts-polar-radius-axis text,\n.dark .phase10-readable .recharts-tooltip-wrapper {\n  fill: #cbd5e1;\n  color: #cbd5e1;\n}\n\n.dark [data-testid=\"header\"] {\n  background: rgba(12, 18, 32, 0.94);\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);\n}\n\n.dark [data-testid=\"header\"] .header-audit-chip,\n.dark [data-testid=\"header\"] .header-search-results,\n.dark [data-testid=\"header\"] .header-date-pill,\n.dark [data-testid=\"header\"] .header-icon-btn {\n  background: rgba(15, 23, 42, 0.78);\n  border-color: rgba(129, 140, 248, 0.28);\n  color: #e2e8f0;\n}\n\n.dark [data-testid=\"header\"] .header-popover {\n  background: #0f172a;\n  border-color: rgba(129, 140, 248, 0.38);\n  color: #f8fafc;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);\n}\n\n.dark [data-testid=\"header\"] .header-popover > div:first-child {\n  background: #111c33;\n  border-bottom-color: rgba(129, 140, 248, 0.26);\n}\n\n.dark [data-testid=\"header\"] .header-title {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"header\"] .header-subtitle,\n.dark [data-testid=\"header\"] .header-empty,\n.dark [data-testid=\"header\"] .header-item-sub {\n  color: #cbd5e1;\n}\n\n.dark [data-testid=\"header\"] .header-item:hover {\n  background: rgba(99, 102, 241, 0.18);\n}\n\n.dark [data-testid=\"header\"] .header-item-title,\n.dark [data-testid=\"header\"] .header-popover-title,\n.dark [data-testid=\"header\"] .header-date-pill {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"header\"] .header-item {\n  color: #f1f5f9;\n}\n\n.header-date-pill,\n.header-icon-btn,\n.header-search-results,\n.header-popover {\n  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.header-search-results { animation-delay: 120ms; }\n.header-date-pill { animation-delay: 180ms; }\n.header-icon-btn { animation-delay: 220ms; }\n.header-popover { animation-delay: 80ms; }\n\n.audit-main .phase2-vscode-shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  background: #0f1117;\n  color: #e5e7eb;\n}\n\n.audit-main .phase2-topbar {\n  align-items: center;\n  background: #e35d1f;\n  color: #ffffff;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  min-height: 44px;\n  padding: 0 14px;\n}\n\n.audit-main .phase2-menu {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 12px;\n  font-weight: 500;\n  opacity: 0.96;\n}\n\n.audit-main .phase2-titlebar {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  gap: 12px;\n  justify-content: space-between;\n  min-width: 0;\n}\n\n.audit-main .phase2-navcluster,\n.audit-main .phase2-title-actions,\n.audit-main .phase2-tabtools {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.audit-main .phase2-navbtn {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #ffffff;\n  display: inline-flex;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.audit-main .phase2-projectpill {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  color: #ffffff;\n  display: inline-flex;\n  gap: 8px;\n  height: 30px;\n  max-width: 420px;\n  min-width: 0;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.audit-main .phase2-title-badge {\n  background: rgba(255, 255, 255, 0.16) !important;\n  border: 1px solid rgba(255, 255, 255, 0.18) !important;\n  color: #ffffff !important;\n}\n\n.audit-main .phase2-update-btn {\n  background: linear-gradient(135deg, #5f87ff 0%, #426df5 100%) !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  color: #ffffff !important;\n  height: 30px;\n  padding: 0 14px;\n}\n\n.audit-main .phase2-tabbar {\n  align-items: center;\n  background: #0b0d12;\n  border-bottom: 1px solid #252a36;\n  display: flex;\n  justify-content: space-between;\n  min-height: 38px;\n  padding: 0 10px;\n}\n\n.audit-main .phase2-tabs {\n  display: flex;\n  gap: 6px;\n  overflow: auto;\n}\n\n.audit-main .phase2-tab {\n  align-items: center;\n  background: #131722;\n  border: 1px solid transparent;\n  border-bottom-color: #131722;\n  border-radius: 8px 8px 0 0;\n  color: #cbd5e1;\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 500;\n  height: 28px;\n  padding: 0 12px;\n  white-space: nowrap;\n}\n\n.audit-main .phase2-tab.is-active {\n  background: #10141d;\n  border-color: #2a303d;\n  border-bottom-color: #10141d;\n  color: #ffffff;\n}\n\n.audit-main .phase2-workspace {\n  display: grid;\n  flex: 1;\n  gap: 0;\n  grid-template-columns: 280px minmax(0, 1fr) 340px;\n  min-height: 0;\n  overflow: hidden;\n  background: #10131a;\n}\n\n.audit-main .phase2-sidebar {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.audit-main .phase2-chatpane {\n  background: #11131a;\n  border-right: 1px solid #242836;\n}\n\n.audit-main .phase2-sourcepane {\n  background: #11131a;\n  border-left: 1px solid #242836;\n}\n\n.audit-main .phase2-sidebar-head {\n  align-items: flex-start;\n  border-bottom: 1px solid #242836;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 14px 12px;\n}\n\n.audit-main .phase2-sidebar-kicker {\n  color: #94a3b8;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n}\n\n.audit-main .phase2-sidebar-head h2 {\n  color: #f8fafc;\n  font-size: 14px;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n.audit-main .phase2-sidebar-actions {\n  align-items: center;\n  display: flex;\n  gap: 6px;\n}\n\n.audit-main .phase2-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n}\n\n.audit-main .phase2-note {\n  align-items: flex-start;\n  color: #cbd5e1;\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.audit-main .phase2-note.is-title {\n  color: #f8fafc;\n  font-weight: 700;\n}\n\n.audit-main .phase2-note-dot {\n  background: #94a3b8;\n  border-radius: 999px;\n  flex-shrink: 0;\n  height: 6px;\n  margin-top: 7px;\n  width: 6px;\n}\n\n.audit-main .phase2-composer {\n  margin-top: auto;\n  padding: 14px;\n  border-top: 1px solid #242836;\n}\n\n.audit-main .phase2-composer-head {\n  display: flex;\n  justify-content: space-between;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.audit-main .phase2-composer-box {\n  background: #0c1117;\n  border: 1px solid #2a303d;\n  border-radius: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n}\n\n.audit-main .phase2-composer-input {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: #e5e7eb !important;\n  height: 34px;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.audit-main .phase2-composer-input::placeholder {\n  color: #94a3b8;\n}\n\n.audit-main .phase2-composer-actions {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.audit-main .phase2-miniicon {\n  color: #cbd5e1;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.audit-main .phase2-smallbtn {\n  align-items: center;\n  background: #151922;\n  border: 1px solid #2a303d;\n  border-radius: 8px;\n  color: #cbd5e1;\n  display: inline-flex;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.audit-main .phase2-sendbtn {\n  align-items: center;\n  background: #e5e7eb;\n  border-radius: 999px;\n  color: #0f172a;\n  display: inline-flex;\n  height: 32px;\n  justify-content: center;\n  margin-left: auto;\n  width: 32px;\n}\n\n.audit-main .phase2-composer-meta {\n  color: #94a3b8;\n  font-size: 11px;\n  margin-top: 8px;\n  text-align: right;\n}\n\n.audit-main .phase2-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 0;\n  overflow: hidden;\n  padding: 14px;\n}\n\n.audit-main .phase2-editor-head {\n  align-items: flex-end;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.audit-main .phase2-editor-path {\n  color: #94a3b8;\n  font-size: 11px;\n  letter-spacing: 0.04em;\n}\n\n.audit-main .phase2-editor-head h1 {\n  color: #f8fafc;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  margin-top: 4px;\n}\n\n.audit-main .phase2-editor-state {\n  align-items: center;\n  background: #11161f;\n  border: 1px solid #2a303d;\n  border-radius: 999px;\n  color: #cbd5e1;\n  display: flex;\n  gap: 8px;\n  font-size: 12px;\n  padding: 6px 10px;\n}\n\n.audit-main .phase2-state-dot {\n  background: #22c55e;\n  border-radius: 999px;\n  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.14);\n  flex-shrink: 0;\n  height: 8px;\n  width: 8px;\n}\n\n.audit-main .phase2-editor-card,\n.audit-main .phase2-terminalpanel {\n  background: #121722 !important;\n  border: 1px solid #2a303d !important;\n  border-radius: 20px;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.audit-main .phase2-editor-card {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.audit-main .phase2-editor-cardhead {\n  padding: 14px 16px 4px;\n}\n\n.audit-main .phase2-editor-title {\n  color: #f8fafc;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.audit-main .phase2-editor-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  overflow: hidden;\n  padding: 8px 16px 16px;\n}\n\n.audit-main .phase2-commandrow {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.audit-main .phase2-commandlabel {\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n\n.audit-main .phase2-select {\n  background: #0f141d !important;\n  border: 1px solid #2a303d !important;\n  color: #e5e7eb !important;\n  height: 40px;\n}\n\n.audit-main .phase2-uploadbtn {\n  align-items: center;\n  background: #0f141d;\n  border: 1px dashed #475569;\n  border-radius: 12px;\n  color: #e5e7eb;\n  cursor: pointer;\n  display: flex;\n  gap: 8px;\n  height: 40px;\n  justify-content: center;\n}\n\n.audit-main .phase2-helptext {\n  color: #94a3b8;\n  font-size: 11px;\n  margin-top: 6px;\n  text-align: center;\n}\n\n.audit-main .phase2-console {\n  background: #0b0f16;\n  border: 1px solid #242836;\n  border-radius: 16px;\n  padding: 12px;\n}\n\n.audit-main .phase2-console-head {\n  color: #cbd5e1;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 11px;\n  margin-bottom: 8px;\n}\n\n.audit-main .phase2-console-title {\n  color: #f8fafc;\n  font-weight: 700;\n}\n\n.audit-main .phase2-console-body {\n  color: #cbd5e1;\n  display: grid;\n  font-size: 12px;\n  gap: 8px 16px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.audit-main .phase2-console-key {\n  color: #94a3b8;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  margin-right: 8px;\n  text-transform: uppercase;\n}\n\n.audit-main .phase2-console-value {\n  color: #e5e7eb;\n  font-weight: 600;\n}\n\n.audit-main .phase2-inlineactions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.audit-main .phase2-actionbtn {\n  background: #151922 !important;\n  border: 1px solid #2a303d !important;\n  color: #e5e7eb !important;\n  height: 38px;\n}\n\n.audit-main .phase2-primarybtn {\n  background: linear-gradient(135deg, #4f7cff 0%, #3b67f6 100%) !important;\n  border: none !important;\n  color: #ffffff !important;\n  height: 38px;\n  box-shadow: none;\n}\n\n.audit-main .phase2-terminalhead {\n  padding: 12px 16px 0;\n}\n\n.audit-main .phase2-terminaltitle {\n  align-items: center;\n  color: #f8fafc;\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.audit-main .phase2-terminalcontent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 16px 14px;\n}\n\n.audit-main .phase2-terminalline {\n  align-items: center;\n  color: #cbd5e1;\n  display: flex;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.audit-main .phase2-terminalline svg {\n  color: #4f7cff;\n}\n\n.audit-main .phase2-sourceactions {\n  display: flex;\n  justify-content: stretch;\n  padding: 12px 14px 0;\n}\n\n.audit-main .phase2-commitbtn {\n  background: #4f7cff !important;\n  border: none !important;\n  color: #fff !important;\n  height: 36px;\n  width: 100%;\n}\n\n.audit-main .phase2-sourcefeed {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 0;\n  overflow: auto;\n  padding: 12px 14px;\n}\n\n.audit-main .phase2-sourceitem {\n  background: #0c1117;\n  border: 1px solid #242836;\n  border-radius: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px;\n}\n\n.audit-main .phase2-sourceitem.is-bad {\n  background: rgba(127, 29, 29, 0.16);\n  border-color: rgba(239, 68, 68, 0.45);\n}\n\n.audit-main .phase2-sourceitem-top {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  min-width: 0;\n}\n\n.audit-main .phase2-source-dot {\n  border-radius: 999px;\n  flex-shrink: 0;\n  height: 8px;\n  width: 8px;\n}\n\n.audit-main .phase2-source-name {\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.audit-main .phase2-sourceitem-meta {\n  color: #94a3b8;\n  display: flex;\n  font-size: 10px;\n  gap: 8px;\n  justify-content: space-between;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.audit-main .phase2-sourceitem-actions {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.audit-main .phase2-source-input {\n  background: #151922;\n  border: 1px solid #2a303d;\n  border-radius: 10px;\n  color: #e5e7eb;\n  flex: 1;\n  font-size: 12px;\n  height: 32px;\n  padding: 0 10px;\n}\n\n.audit-main .phase2-source-delete {\n  align-items: center;\n  background: #1a1113;\n  border: 1px solid #39242a;\n  border-radius: 10px;\n  color: #fca5a5;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n\n.audit-main .phase2-emptyfeed {\n  align-items: center;\n  background: #0c1117;\n  border: 1px dashed #2a303d;\n  border-radius: 16px;\n  color: #94a3b8;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 120px;\n  justify-content: center;\n}\n\n.audit-main .phase2-sourcefooter {\n  color: #94a3b8;\n  font-size: 11px;\n  padding: 0 14px 14px;\n  text-align: center;\n}\n\n.audit-main .phase2-readybadge {\n  background: rgba(34, 197, 94, 0.14) !important;\n  border: 1px solid rgba(34, 197, 94, 0.28) !important;\n  color: #86efac !important;\n}\n\n.dark [data-testid=\"login-page\"] .login-shell {\n  background: rgba(17, 20, 29, 0.78);\n  border-color: rgba(59, 130, 246, 0.12);\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.28);\n}\n\n.dark [data-testid=\"login-page\"] .login-panel {\n  background: rgba(20, 24, 33, 0.92);\n}\n\n.dark [data-testid=\"login-page\"] .login-title {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"login-page\"] .login-copy {\n  color: #94a3b8;\n}\n\n.dark [data-testid=\"login-page\"] .login-card {\n  background: rgba(23, 27, 37, 0.92);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .audit-layout {\n  background: #080a0f;\n  color: #e5e7eb;\n}\n\n.dark .audit-sidebar,\n.dark [data-testid=\"sidebar\"] {\n  background: #0f1117 !important;\n  border-color: #252a36 !important;\n  color: #d1d5db !important;\n}\n\n.dark [data-testid=\"sidebar\"] .audit-brand,\n.dark [data-testid=\"sidebar\"] .audit-panel,\n.dark [data-testid=\"sidebar\"] > div:last-child {\n  background: #0f1117 !important;\n  border-color: #252a36 !important;\n}\n\n.dark [data-testid=\"sidebar\"] .audit-panel {\n  background: #151922 !important;\n}\n\n.audit-main .phase2-page {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  padding: 18px 20px 16px;\n  background:\n    radial-gradient(circle at top left, rgba(34, 197, 94, 0.08), transparent 22%),\n    radial-gradient(circle at top right, rgba(14, 165, 233, 0.06), transparent 18%),\n    linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #0f172a;\n}\n\n.audit-main .phase2-hero {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #e2e8f0;\n  border-radius: 26px;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);\n  display: grid;\n  gap: 18px;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  padding: 18px 22px;\n}\n\n.audit-main .phase2-hero-mark {\n  align-items: center;\n  background: linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%);\n  border: 1px solid #bbf7d0;\n  border-radius: 18px;\n  color: #16a34a;\n  display: grid;\n  height: 58px;\n  place-items: center;\n  width: 58px;\n}\n\n.audit-main .phase2-hero-icon {\n  height: 28px;\n  width: 28px;\n}\n\n.audit-main .phase2-hero-copy {\n  min-width: 0;\n}\n\n.audit-main .phase2-hero-copy h1 {\n  color: #0f172a;\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n}\n\n.audit-main .phase2-hero-copy p {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-top: 4px;\n}\n\n.audit-main .phase2-hero-actions {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n}\n\n.audit-main .phase2-iconbtn {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 14px !important;\n  color: #334155 !important;\n  height: 44px;\n  width: 44px;\n}\n\n.audit-main .phase2-primarybtn {\n  align-items: center;\n  background: linear-gradient(135deg, #1f9d57 0%, #15924e 100%) !important;\n  border: none !important;\n  border-radius: 14px !important;\n  box-shadow: 0 14px 30px rgba(21, 146, 78, 0.22);\n  color: #ffffff !important;\n  display: inline-flex;\n  gap: 8px;\n  height: 44px;\n  padding: 0 18px;\n}\n\n.audit-main .phase2-upload-card {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid #dbeadf;\n  border-radius: 24px;\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.05);\n}\n\n.audit-main .phase2-upload-content {\n  padding: 18px 22px 20px;\n}\n\n.audit-main .phase2-upload-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: minmax(260px, 0.86fr) minmax(0, 1.14fr);\n}\n\n.audit-main .phase2-field-label {\n  color: #1e293b;\n  display: block;\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.audit-main .phase2-select {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 14px !important;\n  color: #0f172a !important;\n  height: 48px;\n}\n\n.audit-main .phase2-dropzone {\n  align-items: center;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  border: 1px dashed #cdd7e3;\n  border-radius: 16px;\n  color: #334155;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: center;\n  min-height: 98px;\n  text-align: center;\n}\n\n.audit-main .phase2-dropzone strong {\n  color: #16a34a;\n}\n\n.audit-main .phase2-dropzone small {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.audit-main .phase2-dropzone-status {\n  align-items: center;\n  color: #15803d;\n  display: inline-flex;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n.audit-main .phase2-docs-card {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid #e2e8f0;\n  border-radius: 24px;\n  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.audit-main .phase2-docs-header {\n  align-items: center;\n  border-bottom: 1px solid #edf2f7;\n  display: grid;\n  gap: 14px;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  padding: 16px 20px 14px;\n}\n\n.audit-main .phase2-docs-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.audit-main .phase2-docs-title {\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.audit-main .phase2-status-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.audit-main .phase2-pill {\n  align-items: center;\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 999px;\n  color: #334155 !important;\n  display: inline-flex;\n  gap: 8px;\n  height: 30px;\n  padding: 0 12px;\n}\n\n.audit-main .phase2-pill-ready {\n  background: #f0fdf4 !important;\n  border-color: #bbf7d0 !important;\n  color: #15803d !important;\n}\n\n.audit-main .phase2-pill-processing {\n  background: #eff6ff !important;\n  border-color: #bfdbfe !important;\n  color: #2563eb !important;\n}\n\n.audit-main .phase2-pill-failed {\n  background: #fef2f2 !important;\n  border-color: #fecaca !important;\n  color: #ef4444 !important;\n}\n\n.audit-main .phase2-pill-dot {\n  background: currentColor;\n  border-radius: 999px;\n  display: inline-block;\n  height: 8px;\n  width: 8px;\n}\n\n.audit-main .phase2-searchbox {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #dbe3ee;\n  border-radius: 14px;\n  color: #64748b;\n  display: flex;\n  gap: 10px;\n  height: 42px;\n  min-width: 270px;\n  padding: 0 14px;\n}\n\n.audit-main .phase2-searchinput {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  height: 40px;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.audit-main .phase2-searchinput:focus {\n  box-shadow: none !important;\n}\n\n.audit-main .phase2-filterbtn {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 14px !important;\n  color: #334155 !important;\n  height: 42px;\n  padding: 0 14px;\n}\n\n.audit-main .phase2-docs-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 14px;\n  min-height: 0;\n  overflow: hidden;\n  padding: 14px 20px 18px;\n}\n\n.audit-main .phase2-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  justify-content: space-between;\n}\n\n.audit-main .phase2-toolbar-filters,\n.audit-main .phase2-toolbar-actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.audit-main .phase2-toolbar-select {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 12px !important;\n  color: #0f172a !important;\n  height: 40px;\n  min-width: 158px;\n}\n\n.audit-main .phase2-toolbar-btn {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 12px !important;\n  color: #334155 !important;\n  height: 40px;\n}\n\n.audit-main .phase2-tablewrap {\n  background: #ffffff;\n  border: 1px solid #e8edf4;\n  border-radius: 18px;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.audit-main .phase2-table {\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n}\n\n.audit-main .phase2-table thead th {\n  background: #f8fafc;\n  border-bottom: 1px solid #edf2f7;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  padding: 13px 14px;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.audit-main .phase2-table tbody td {\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  padding: 12px 14px;\n  vertical-align: middle;\n}\n\n.audit-main .phase2-col-check {\n  width: 34px;\n  text-align: center;\n}\n\n.audit-main .phase2-col-actions {\n  width: 54px;\n  text-align: right;\n}\n\n.audit-main .phase2-filecell {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n  min-width: 0;\n}\n\n.audit-main .phase2-fileicon {\n  align-items: center;\n  background: #ecfdf5;\n  border: 1px solid #ccefd7;\n  border-radius: 10px;\n  color: #16a34a;\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.audit-main .phase2-filename {\n  color: #1e293b;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.audit-main .phase2-type-badge {\n  background: #eef2ff !important;\n  border: 1px solid #ddd6fe !important;\n  color: #6d28d9 !important;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.audit-main .phase2-classification-input {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 12px !important;\n  color: #334155 !important;\n  font-size: 12px;\n  height: 36px;\n  width: 100%;\n}\n\n.audit-main .phase2-status-cell {\n  align-items: center;\n  display: inline-flex;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.audit-main .phase2-status-ready {\n  color: #16a34a;\n}\n\n.audit-main .phase2-status-processing {\n  color: #2563eb;\n}\n\n.audit-main .phase2-status-failed {\n  color: #ef4444;\n}\n\n.audit-main .phase2-ready-dot {\n  background: #16a34a;\n  border-radius: 999px;\n  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.14);\n  display: inline-block;\n  flex-shrink: 0;\n  height: 8px;\n  width: 8px;\n}\n\n.audit-main .phase2-mono {\n  color: #475569;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.audit-main .phase2-row-action {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #64748b;\n  display: inline-flex;\n  height: 30px;\n  justify-content: center;\n  margin-left: auto;\n  width: 30px;\n}\n\n.audit-main .phase2-row-failed td {\n  background: rgba(254, 242, 242, 0.72);\n}\n\n.audit-main .phase2-emptytable {\n  align-items: center;\n  color: #94a3b8;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  justify-content: center;\n  min-height: 112px;\n}\n\n.audit-main .phase2-footer {\n  align-items: center;\n  color: #64748b;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr auto auto;\n  font-size: 13px;\n}\n\n.audit-main .phase2-pagination {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.audit-main .phase2-pagebtn {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #dbe3ee;\n  border-radius: 10px;\n  color: #64748b;\n  display: inline-flex;\n  height: 34px;\n  justify-content: center;\n  width: 34px;\n}\n\n.audit-main .phase2-pagebtn.is-active {\n  background: #16a34a;\n  border-color: #16a34a;\n  color: #ffffff;\n}\n\n.audit-main .phase2-pagegap {\n  color: #cbd5e1;\n}\n\n.audit-main .phase2-rowsperpage {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.audit-main .phase2-rows-select {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 10px !important;\n  color: #0f172a !important;\n  height: 34px;\n  min-width: 78px;\n}\n\n.audit-main .phase2-bottom-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.audit-main .phase2-savebtn {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 14px !important;\n  color: #334155 !important;\n  height: 44px;\n  padding: 0 18px;\n}\n\n.audit-main .phase2-continue-bottom {\n  min-width: 248px;\n}\n\n.audit-main .phase2-page .phase2-primarybtn:hover,\n.audit-main .phase2-savebtn:hover,\n.audit-main .phase2-iconbtn:hover,\n.audit-main .phase2-toolbar-btn:hover,\n.audit-main .phase2-filterbtn:hover,\n.audit-main .phase2-row-action:hover,\n.audit-main .phase2-pagebtn:hover {\n  transform: translateY(-1px);\n}\n\n\n.dark [data-testid=\"sidebar\"] p,\n.dark [data-testid=\"sidebar\"] span {\n  color: inherit;\n}\n\n.dark [data-testid=\"sidebar\"] .text-\\[\\#0a0a0a\\],\n.dark [data-testid=\"sidebar\"] .text-\\[\\#364153\\] {\n  color: #e5e7eb !important;\n}\n\n.dark [data-testid=\"sidebar\"] .text-\\[\\#6a7282\\],\n.dark [data-testid=\"sidebar\"] .text-muted-foreground {\n  color: #94a3b8 !important;\n}\n\n.dark [data-testid=\"sidebar\"] .sidebar-nav-item {\n  color: #cbd5e1 !important;\n}\n\n.dark [data-testid=\"sidebar\"] .sidebar-nav-item:hover {\n  background: #1b202b !important;\n}\n\n.dark [data-testid=\"sidebar\"] .sidebar-nav-item.active,\n.dark [data-testid=\"sidebar\"] .bg-\\[\\#bcbcbc\\] {\n  background: #2a303d !important;\n  color: #f8fafc !important;\n}\n\n.dark [data-testid=\"sidebar\"] button[title=\"Refresh audit runs\"] {\n  background: #121722 !important;\n  border-color: rgba(52, 211, 153, 0.34) !important;\n  color: #f8fafc !important;\n}\n\n.dark .audit-header,\n.dark [data-testid=\"header\"] {\n  background: rgba(15, 17, 23, 0.92) !important;\n  border-bottom-color: #252a36 !important;\n  color: #e5e7eb !important;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);\n  backdrop-filter: blur(16px);\n}\n\n.dark [data-testid=\"header\"] .header-audit-chip,\n.dark [data-testid=\"header\"] .header-search-results,\n.dark [data-testid=\"header\"] .header-popover,\n.dark [data-testid=\"header\"] .header-date-pill,\n.dark [data-testid=\"header\"] .header-icon-btn,\n.dark [data-testid=\"header\"] .header-search-input,\n.dark [data-testid=\"header\"] .header-avatar,\n.dark [data-testid=\"header\"] input {\n  background: #151922 !important;\n  border-color: #2a303d !important;\n  color: #e5e7eb !important;\n}\n\n.dark [data-testid=\"header\"] input::placeholder {\n  color: #94a3b8 !important;\n}\n\n.dark [data-testid=\"header\"] svg {\n  color: #94a3b8;\n}\n\n.dark .audit-main {\n  background: #080a0f;\n  box-shadow: inset -1px 0 0 #252a36;\n}\n\n.dark .audit-main::before {\n  display: none;\n}\n\n.dark .audit-main .bg-card,\n.dark .audit-main [class*=\"bg-card/\"],\n.dark .audit-main .bg-background,\n.dark .audit-main .bg-white,\n.dark .audit-main [class*=\"bg-white/\"] {\n  background-color: #151922 !important;\n}\n\n.dark .audit-main .border,\n.dark .audit-main [class*=\"border-\"] {\n  border-color: #2a303d;\n}\n\n.dark .audit-main .text-slate-900,\n.dark .audit-main .text-slate-800,\n.dark .audit-main .text-slate-700,\n.dark .audit-main .text-gray-900,\n.dark .audit-main .text-gray-800,\n.dark .audit-main .text-\\[\\#0a0a0a\\],\n.dark .audit-main .text-\\[\\#364153\\],\n.dark .audit-main .text-\\[\\#4a5565\\] {\n  color: #f8fafc !important;\n}\n\n.dark .audit-main .text-muted-foreground,\n.dark .audit-main .text-slate-600,\n.dark .audit-main .text-slate-500,\n.dark .audit-main .text-gray-500,\n.dark .audit-main .text-\\[\\#6a7282\\],\n.dark .audit-main .text-\\[\\#94a3b8\\] {\n  color: #94a3b8 !important;\n}\n\n.dark .audit-main input,\n.dark .audit-main textarea,\n.dark .audit-main button[role=\"combobox\"] {\n  background: #10141d !important;\n  border-color: #2a303d !important;\n  color: #f8fafc !important;\n}\n\n.dark .audit-chat,\n.dark .audit-chat-panel,\n.dark .audit-chat-panel .chat-header,\n.dark .audit-chat-panel .chat-composer {\n  background: #0f1117 !important;\n  border-color: #252a36 !important;\n  color: #e5e7eb !important;\n}\n\n.dark .audit-chat-panel p,\n.dark .audit-chat-panel span,\n.dark .audit-chat-panel .text-\\[\\#0a0a0a\\],\n.dark .audit-chat-panel .text-\\[\\#4a5565\\],\n.dark .audit-chat-panel .text-black {\n  color: #e5e7eb !important;\n}\n\n.dark .audit-chat-panel .text-\\[\\#6a7282\\],\n.dark .audit-chat-panel .text-muted-foreground {\n  color: #94a3b8 !important;\n}\n\n.dark .audit-chat-panel input,\n.dark .audit-chat-panel .chat-composer button {\n  background: #151922 !important;\n  border-color: #3b4251 !important;\n  color: #e5e7eb !important;\n}\n\n.audit-main .phase1-figma {\n  color: #0f172a;\n}\n\n.audit-main .phase1-shell {\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  padding: 18px 20px 16px;\n}\n\n.audit-main .phase1-fit {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.audit-main .phase1-top-card {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 24px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);\n  display: flex;\n  gap: 24px;\n  justify-content: flex-start;\n  margin-bottom: 0;\n  padding: 16px 20px;\n}\n\n.audit-main .phase1-title-block {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  min-width: 0;\n  width: 100%;\n}\n\n.audit-main .phase1-hero-badge {\n  align-items: center;\n  background: linear-gradient(135deg, #1f9d5a 0%, #0f8a49 100%);\n  border-radius: 999px;\n  box-shadow: 0 10px 20px rgba(15, 138, 73, 0.16);\n  display: flex;\n  flex-shrink: 0;\n  height: 52px;\n  justify-content: center;\n  width: 52px;\n}\n\n.audit-main .phase1-hero-badge-num {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.audit-main .phase1-title-copy {\n  min-width: 0;\n}\n\n.audit-main .phase1-title-copy h1 {\n  color: #1e293b;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n}\n\n.audit-main .phase1-title-copy p {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.45;\n  margin-top: 8px;\n  max-width: 800px;\n}\n\n.audit-main .phase1-empty-state {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0 0;\n}\n\n.audit-main .phase1-empty-card {\n  background: #ffffff !important;\n  border: 1px solid rgba(148, 163, 184, 0.16) !important;\n  border-radius: 24px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);\n  max-width: 520px;\n  width: 100%;\n}\n\n.audit-main .phase1-empty-content {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 24px 22px;\n  text-align: center;\n}\n\n.audit-main .phase1-empty-icon {\n  align-items: center;\n  background: linear-gradient(180deg, #f0fdf4 0%, #dcfce7 100%);\n  border-radius: 22px;\n  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.12);\n  display: flex;\n  height: 64px;\n  justify-content: center;\n  margin-bottom: 14px;\n  width: 64px;\n}\n\n.audit-main .phase1-empty-content h2 {\n  color: #1e293b;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.audit-main .phase1-empty-content p {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.5;\n  margin-top: 6px;\n}\n\n.audit-main .phase1-panel {\n  background: rgba(255, 255, 255, 0.9) !important;\n  border: 1px solid rgba(148, 163, 184, 0.16) !important;\n  border-radius: 24px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.audit-main .phase1-card-header {\n  padding: 14px 18px 4px;\n}\n\n.audit-main .phase1-card-title {\n  color: #0f172a;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.audit-main .phase1-card-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 10px;\n  min-height: 0;\n  overflow: hidden;\n  padding: 2px 18px 14px;\n}\n\n.audit-main .phase1-label {\n  color: #1e293b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.audit-main .phase1-input,\n.audit-main .phase1-select {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  color: #0f172a !important;\n  color-scheme: light;\n  height: 40px;\n}\n\n.audit-main .phase1-input::placeholder {\n  color: #94a3b8;\n}\n\n.audit-main .phase1-input:focus-visible,\n.audit-main .phase1-select:focus-visible {\n  box-shadow: 0 0 0 3px rgba(31, 157, 90, 0.16);\n  outline: none;\n}\n\n.audit-main .phase1-domain-grid {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.audit-main .phase1-domain-btn,\n.audit-main .phase1-chip,\n.audit-main .phase1-badge,\n.audit-main .phase1-outline-btn {\n  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, color 160ms ease, box-shadow 160ms ease;\n}\n\n.audit-main .phase1-domain-btn {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #d9e1ec;\n  border-radius: 16px;\n  color: #334155;\n  display: flex;\n  gap: 12px;\n  min-height: 42px;\n  padding: 10px 12px;\n  position: relative;\n}\n\n.audit-main .phase1-domain-icon {\n  align-items: center;\n  color: #334155;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n}\n\n.audit-main .phase1-domain-label {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: left;\n}\n\n.audit-main .phase1-domain-check {\n  color: #1f9d5a;\n  margin-left: auto;\n}\n\n.audit-main .phase1-domain-btn:hover,\n.audit-main .phase1-chip:hover,\n.audit-main .phase1-badge:hover,\n.audit-main .phase1-outline-btn:hover {\n  transform: translateY(-1px);\n}\n\n.audit-main .phase1-domain-btn.is-active {\n  background: #f4fbf7;\n  border-color: #1f9d5a;\n  box-shadow: inset 0 0 0 1px rgba(31, 157, 90, 0.08);\n  color: #0f7a43;\n}\n\n.audit-main .phase1-domain-btn.is-active .phase1-domain-icon {\n  color: #0f7a43;\n}\n\n.audit-main .phase1-banner {\n  align-items: flex-start;\n  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);\n  border: 1px solid #dbeafe;\n  border-radius: 14px;\n  color: #35506b;\n  display: flex;\n  gap: 12px;\n  padding: 8px 10px;\n}\n\n.audit-main .phase1-banner-icon {\n  align-items: center;\n  background: #2563eb;\n  border-radius: 999px;\n  color: #ffffff;\n  display: flex;\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 700;\n  height: 20px;\n  justify-content: center;\n  line-height: 1;\n  margin-top: 2px;\n  width: 20px;\n}\n\n.audit-main .phase1-banner p {\n  font-size: 13px;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.audit-main .phase1-grid-two {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.audit-main .phase1-grid-three {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.8fr);\n}\n\n.audit-main .phase1-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.audit-main .phase1-input-shell {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #dbe3ee;\n  border-radius: 14px;\n  display: flex;\n  gap: 10px;\n  min-height: 40px;\n  padding: 0 12px;\n}\n\n.audit-main .phase1-input-shell .phase1-input-with-icon {\n  border: 0 !important;\n  box-shadow: none !important;\n  flex: 1;\n  height: 38px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.audit-main .phase1-field-icon,\n.audit-main .phase1-field-chevron {\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.audit-main .phase1-chip-cloud,\n.audit-main .phase1-chip-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.audit-main .phase1-chip,\n.audit-main .phase1-badge {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #dbe3ee !important;\n  border-radius: 999px;\n  color: #334155;\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 500;\n  gap: 6px;\n  min-height: 30px;\n  padding: 5px 10px;\n}\n\n.audit-main .phase1-chip.is-active,\n.audit-main .phase1-badge.is-active {\n  background: #eaf9f0;\n  border-color: #1f9d5a !important;\n  color: #0f7a43;\n}\n\n.audit-main .phase1-inline-add {\n  display: flex;\n  gap: 6px;\n}\n\n.audit-main .phase1-inline-input {\n  flex: 1;\n  height: 36px;\n}\n\n.audit-main .phase1-add-btn,\n.audit-main .phase1-secondary-btn {\n  flex-shrink: 0;\n  min-width: 78px;\n}\n\n.audit-main .phase1-helper {\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.audit-main .phase1-text-link {\n  color: #1f9d5a;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.audit-main .phase1-recommendation span {\n  color: #1f9d5a;\n  font-weight: 700;\n}\n\n.audit-main .phase1-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding-top: 0;\n}\n\n.audit-main .phase1-primary-btn {\n  background: linear-gradient(135deg, #24a35a 0%, #15803d 100%) !important;\n  border: 1px solid #15803d !important;\n  box-shadow: 0 14px 28px rgba(21, 128, 61, 0.18);\n  color: #ffffff !important;\n  min-width: 164px;\n}\n\n.audit-main .phase1-primary-btn:hover {\n  background: linear-gradient(135deg, #2fb165 0%, #166534 100%) !important;\n  color: #ffffff !important;\n}\n\n.audit-main .phase1-outline-btn {\n  background: #ffffff !important;\n  border: 1px solid #dbe3ee !important;\n  color: #334155;\n}\n\n.audit-main .phase1-secondary-btn {\n  min-width: 120px;\n}\n\n.audit-main .phase1-outline-btn:hover {\n  background: #f8fbff !important;\n  border-color: #cbd5e1 !important;\n}\n\n.dark .audit-main .phase1-figma {\n  color: #e5e7eb;\n}\n\n.dark .audit-main .phase1-top-card,\n.dark .audit-main .phase1-panel,\n.dark .audit-main .phase1-empty-card {\n  background: rgba(17, 24, 39, 0.9) !important;\n  border-color: rgba(148, 163, 184, 0.16) !important;\n}\n\n.dark .audit-main .phase1-title-copy h1,\n.dark .audit-main .phase1-card-title,\n.dark .audit-main .phase1-label,\n.dark .audit-main .phase1-empty-content h2 {\n  color: #f8fafc;\n}\n\n.dark .audit-main .phase1-title-copy p,\n.dark .audit-main .phase1-helper,\n.dark .audit-main .phase1-empty-content p,\n.dark .audit-main .phase1-banner p,\n.dark .audit-main .phase1-domain-label {\n  color: #cbd5e1;\n}\n\n.dark .audit-main .phase1-stepper-dot,\n.dark .audit-main .phase1-domain-btn,\n.dark .audit-main .phase1-chip,\n.dark .audit-main .phase1-badge,\n.dark .audit-main .phase1-input,\n.dark .audit-main .phase1-select,\n.dark .audit-main .phase1-input-shell,\n.dark .audit-main .phase1-outline-btn {\n  background: #0f172a !important;\n  border-color: #243246 !important;\n  color: #e5e7eb !important;\n}\n\n.dark .audit-main .phase1-stepper-line {\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.45), rgba(148, 163, 184, 0.12));\n}\n\n.dark .audit-main .phase1-banner {\n  background: linear-gradient(180deg, rgba(30, 41, 59, 0.92) 0%, rgba(15, 23, 42, 0.98) 100%);\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n.dark .audit-main .phase1-domain-btn.is-active {\n  background: rgba(15, 118, 67, 0.22);\n  border-color: rgba(34, 197, 94, 0.55);\n  color: #ecfdf5;\n}\n\n.dark .audit-main .phase1-chip.is-active,\n.dark .audit-main .phase1-badge.is-active {\n  background: rgba(15, 118, 67, 0.22);\n  border-color: rgba(34, 197, 94, 0.55) !important;\n  color: #ecfdf5;\n}\n\n.dark .audit-main .phase1-primary-btn {\n  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;\n  border-color: #16a34a !important;\n}\n\n.audit-main .connections-page {\n  color: #0a0a0a;\n}\n\n.audit-main .connections-title {\n  color: #0a0a0a;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 0.0703px;\n  line-height: 32px;\n}\n\n.audit-main .connections-subtitle,\n.audit-main .connections-card-subtitle {\n  color: #4a5565;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 4px;\n}\n\n.audit-main .connections-card {\n  background: #ffffff !important;\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\n  border-radius: 14px;\n  box-shadow: none;\n}\n\n.audit-main .connections-card-header {\n  padding: 20px 20px 12px;\n}\n\n.audit-main .connections-card-title {\n  color: #0a0a0a;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.4395px;\n  line-height: 28px;\n}\n\n.audit-main .connections-card-content {\n  padding: 0 20px 20px;\n}\n\n.audit-main .connections-stat-card {\n  height: 76px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\n  border-radius: 14px;\n  background: linear-gradient(162.55deg, #f3f4f6 0%, #e5e7eb 100%) !important;\n  color: #364153;\n  box-shadow: none;\n}\n\n.audit-main .connections-stat-card.is-red,\n.audit-main .connections-stat-card.is-dark {\n  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;\n  color: #ffffff;\n}\n\n.audit-main .connections-stat-value {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 0.3955px;\n  line-height: 36px;\n}\n\n.audit-main .connections-stat-label {\n  font-size: 14px;\n  line-height: 20px;\n  opacity: 0.9;\n}\n\n.audit-main .connections-stat-icon {\n  align-items: center;\n  background: #d1d5dc;\n  border-radius: 9999px;\n  color: #364153;\n  display: flex;\n  height: 34px;\n  justify-content: center;\n  width: 34px;\n}\n\n.audit-main .connections-stat-card.is-red .connections-stat-icon,\n.audit-main .connections-stat-card.is-dark .connections-stat-icon {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.dark .audit-main .connections-page,\n.dark .audit-main .connections-title,\n.dark .audit-main .connections-card-title {\n  color: #f8fafc !important;\n}\n\n.dark .audit-main .connections-subtitle,\n.dark .audit-main .connections-card-subtitle {\n  color: #94a3b8 !important;\n}\n\n.dark .audit-main .connections-card {\n  background: #151922 !important;\n  border-color: #2a303d !important;\n}\n\n.dark .audit-main .connections-stat-card {\n  border-color: #2a303d !important;\n  background: linear-gradient(162.55deg, #1b202b 0%, #252a36 100%) !important;\n  color: #cbd5e1;\n}\n\n.dark .audit-main .connections-stat-card.is-red,\n.dark .audit-main .connections-stat-card.is-dark {\n  background: linear-gradient(162.55deg, #050506 0%, #7f0505 100%) !important;\n  color: #ffffff;\n}\n\n.dark .audit-main .connections-stat-icon {\n  background: #2a303d;\n  color: #cbd5e1;\n}\n\n.audit-main .user-page {\n  color: #0a0a0a;\n}\n\n.audit-main .user-role-card {\n  height: 76px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\n  border-radius: 14px;\n  background: linear-gradient(162.55deg, #f3f4f6 0%, #e5e7eb 100%) !important;\n  color: #364153;\n  box-shadow: none;\n}\n\n.audit-main .user-role-card.is-highlighted {\n  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;\n  color: #ffffff;\n}\n\n.audit-main .user-role-card:nth-child(2).is-highlighted {\n  background: linear-gradient(162.55deg, #000000 0%, #bb0000 100%) !important;\n}\n\n.audit-main .user-role-card:nth-child(3).is-highlighted,\n.audit-main .user-role-card:nth-child(5).is-highlighted {\n  background: linear-gradient(162.55deg, #bb0000 0%, #000000 100%) !important;\n}\n\n.audit-main .user-role-icon {\n  align-items: center;\n  background: #d1d5dc;\n  border-radius: 9999px;\n  color: #364153;\n  display: flex;\n  height: 34px;\n  justify-content: center;\n  width: 34px;\n}\n\n.audit-main .user-role-card.is-highlighted .user-role-icon {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.audit-main .user-table-card {\n  border: 1px solid rgba(0, 0, 0, 0.1) !important;\n  border-radius: 14px;\n  background: #ffffff !important;\n  box-shadow: none;\n}\n\n.audit-main .user-table {\n  overflow: hidden;\n  border-radius: 14px;\n}\n\n.audit-main .user-table th {\n  height: 38px;\n  color: #4a5565;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.1504px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.audit-main .user-table td {\n  height: 46px;\n  color: #4a5565;\n  font-size: 14px;\n  letter-spacing: -0.1504px;\n  line-height: 20px;\n}\n\n.audit-main .user-table tr {\n  border-color: #f3f4f6;\n}\n\n.audit-main .user-role-badge,\n.audit-main .user-status-badge {\n  align-items: center;\n  border-radius: 8px;\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 500;\n  height: 22px;\n  line-height: 16px;\n  padding: 3px 9px;\n  text-transform: none;\n}\n\n.audit-main .user-status-badge.is-active {\n  background: #dcfce7;\n  border-color: transparent;\n  color: #008236;\n}\n\n.audit-main .user-status-badge.is-disabled {\n  background: #fee2e2;\n  border-color: transparent;\n  color: #dc2626;\n}\n\n.dark .audit-main .user-page {\n  color: #f8fafc;\n}\n\n.dark .audit-main .user-page h2,\n.dark .audit-main .user-table-card [class*=\"CardTitle\"],\n.dark .audit-main .user-table td:first-child {\n  color: #f8fafc !important;\n}\n\n.dark .audit-main .user-role-card {\n  border-color: #2a303d !important;\n  background: linear-gradient(162.55deg, #1b202b 0%, #252a36 100%) !important;\n  color: #cbd5e1;\n}\n\n.dark .audit-main .user-role-card.is-highlighted {\n  background: linear-gradient(162.55deg, #050506 0%, #7f0505 100%) !important;\n  color: #ffffff;\n}\n\n.dark .audit-main .user-table-card {\n  background: #151922 !important;\n  border-color: #2a303d !important;\n}\n\n.dark .audit-main .user-table th,\n.dark .audit-main .user-table td {\n  color: #cbd5e1 !important;\n}\n\n.dark .audit-main .user-table tr {\n  border-color: #252a36;\n}\n\n.dark .audit-main .user-role-icon {\n  background: #2a303d;\n  color: #cbd5e1;\n}\n\n.dark .audit-main .user-role-card.is-highlighted .user-role-icon {\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n}\n\n.ai-sparkle {\n  animation: sparkleSpin 2.6s linear infinite;\n}\n\n.heatmap-threshold-bg {\n  background:\n    linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(220, 38, 38, 0.12) 48%, rgba(239, 68, 68, 0.12) 100%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(254, 242, 242, 0.45));\n  border: 1px solid rgba(254, 202, 202, 0.65);\n}\n\n.quick-actions-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quick-actions-item {\n  width: 100%;\n  text-align: left;\n  border: 1px solid rgba(254, 202, 202, 0.7);\n  background: rgba(255, 250, 250, 0.9);\n  border-radius: 14px;\n  padding: 8px;\n  animation: rowIn 420ms ease both;\n  animation-delay: var(--qa-delay, 0ms);\n  transition: transform 170ms ease, box-shadow 170ms ease;\n}\n\n.quick-actions-item:hover {\n  transform: translateX(4px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);\n}\n\n.quick-actions-track {\n  height: 6px;\n  border-radius: 999px;\n  margin-top: 6px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.quick-actions-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #b91c1c, #ef4444);\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.agent-scanning {\n  letter-spacing: 0.02em;\n}\n\n.assistant-overlay {\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  border-radius: 16px;\n  background: linear-gradient(135deg, rgba(254, 242, 242, 0.97), rgba(255, 250, 250, 0.96));\n  padding: 10px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.assistant-task-row {\n  animation: rowIn 420ms ease both;\n  animation-delay: var(--task-delay, 0ms);\n}\n\n.assistant-task-track {\n  height: 5px;\n  border-radius: 999px;\n  background: #fecaca;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.assistant-task-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #b91c1c, #ef4444);\n  animation: progressGrow 800ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.assistant-overlay-card {\n  background: linear-gradient(145deg, rgba(255, 250, 250, 0.95), rgba(254, 242, 242, 0.98));\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n}\n\n.typing-dots::after {\n  content: \"...\";\n  display: inline-block;\n  width: 12px;\n  overflow: hidden;\n  vertical-align: bottom;\n  animation: typingDots 1.1s steps(4, end) infinite;\n}\n\n/* Keyframes */\n@keyframes orbFloat {\n  from { transform: translateY(-8px) scale(1); }\n  to { transform: translateY(10px) scale(1.05); }\n}\n\n@keyframes particlesDrift {\n  from { transform: translateY(0); }\n  to { transform: translateY(-20px); }\n}\n\n@keyframes navItemIn {\n  from { opacity: 0; transform: translateX(-10px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes sidebarIn {\n  from { opacity: 0; transform: translateX(-16px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes metricIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes rowIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes progressGrow {\n  from { transform: scaleX(0); }\n  to { transform: scaleX(1); }\n}\n\n@keyframes phasePageIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.99); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes phaseSectionIn {\n  from { opacity: 0; transform: translateY(14px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes phaseDotIn {\n  from { opacity: 0; transform: scale(0.82); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n@keyframes currentPhasePulse {\n  0%, 100% {\n    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);\n  }\n  50% {\n    box-shadow: 0 0 0 9px rgba(99, 102, 241, 0.08), 0 0 28px rgba(45, 212, 191, 0.24);\n  }\n}\n\n@keyframes heroGradientDrift {\n  from { background-position: 0% 0%, 0% 0%, 0% 0%; }\n  to { background-position: 5% 8%, -4% 4%, 100% 100%; }\n}\n\n@keyframes messageSlideIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.96); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes messageShimmer {\n  0% { transform: translateX(-125%); }\n  45%, 100% { transform: translateX(125%); }\n}\n\n@keyframes typingBounce {\n  0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }\n  40% { transform: translateY(-4px); opacity: 1; }\n}\n\n@keyframes sendPulse {\n  0%, 100% { box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34); }\n  50% { box-shadow: 0 16px 36px rgba(45, 212, 191, 0.26); }\n}\n\n@keyframes scanSweep {\n  0% { transform: translateX(-120%); }\n  55%, 100% { transform: translateX(120%); }\n}\n\n@keyframes bellPulse {\n  0%, 100% { opacity: 0.9; transform: scale(1); }\n  50% { opacity: 0.45; transform: scale(0.84); }\n}\n\n@keyframes floatBtnIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.92); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes sparkleSpin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes typingDots {\n  0% { width: 0; }\n  100% { width: 12px; }\n}\n\n@keyframes healthPulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 var(--pulse-color, rgba(148, 163, 184, 0.4));\n  }\n  70% {\n    transform: scale(1.02);\n    box-shadow: 0 0 0 7px transparent;\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ambient-orb,\n  .ambient-particles,\n  .sidebar-nav-item,\n  .metric-card-anim,\n  .table-row-anim,\n  .progress-anim,\n  .notification-pulse,\n  .floating-ai-btn,\n  .ai-sparkle,\n  .phase-step-dot,\n  .phase-step-line::after,\n  [data-testid^=\"phase-\"],\n  [data-testid^=\"phase-\"] > *,\n  .phase7-hero,\n  .phase7-console-card,\n  .phase7-control-row,\n  .phase7-progress-card,\n  .header-date-pill,\n  .header-icon-btn,\n  .header-search-results,\n  .header-popover,\n  .audit-card,\n  .copilot-message-row,\n  .copilot-user-message::after,\n  .copilot-send-armed,\n  .copilot-send-armed::after,\n  .copilot-typing-dots span,\n  .progress-bar-indicator::after,\n  .hero-progress-fill::after,\n  .quick-actions-fill::after,\n  .assistant-task-fill::after {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n@media (max-width: 1280px) {\n  .audit-layout {\n    grid-template-columns: 14.5rem minmax(0, 1fr) clamp(19rem, 24vw, 22rem);\n  }\n}\n\n@media (max-width: 1100px) {\n  .audit-layout,\n  .audit-layout.chat-closed {\n    grid-template-columns: 13.5rem 1fr;\n  }\n\n  .audit-chat {\n    display: none;\n  }\n\n  .audit-sidebar .sidebar-nav-item {\n    padding-left: 1rem;\n  }\n\n  .audit-sidebar .sidebar-stepper::before {\n    display: none;\n  }\n}\n\n@media (max-width: 860px) {\n  .audit-layout,\n  .audit-layout.chat-closed {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto 1fr;\n    height: auto;\n    min-height: 100vh;\n    overflow: auto;\n  }\n\n  .audit-sidebar {\n    grid-row: 1;\n    grid-column: 1;\n  }\n\n  .audit-header {\n    grid-row: 2;\n    grid-column: 1;\n  }\n\n  .audit-main {\n    grid-row: 3;\n    grid-column: 1;\n    min-height: 0;\n  }\n\n  .audit-sidebar {\n    height: auto;\n  }\n\n  .audit-brand {\n    padding-top: 0.9rem;\n    padding-bottom: 0.9rem;\n  }\n\n  .audit-panel {\n    padding: 0.75rem;\n  }\n\n@keyframes samplingPopupIn {\n  0% { opacity: 0; transform: translateY(24px) scale(0.92); }\n  60% { opacity: 1; transform: translateY(-4px) scale(1.02); }\n  100% { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.sampling-popup {\n  animation: samplingPopupIn 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.sampling-popup-backdrop {\n  animation: samplingFadeIn 0.3s ease both;\n}\n\n@keyframes samplingFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes findingCardIn {\n  from { opacity: 0; transform: translateY(16px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes findingCardOut {\n  from { opacity: 1; transform: translateY(0) scale(1); }\n  to { opacity: 0; transform: translateY(-12px) scale(0.97); }\n}\n\n.finding-card-in {\n  animation: findingCardIn 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: var(--finding-delay, 0ms);\n}\n\n.finding-card-out {\n  animation: findingCardOut 0.28s ease forwards;\n  pointer-events: none;\n}\n\n\n  .floating-ai-btn {\n    right: 0.8rem;\n    bottom: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
